function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("fq6gA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$823b8d03c72b8ec8$export$2e2bcd8739ae039);
    var $cBeZP;
    let $823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler = true;
    const $823b8d03c72b8ec8$var$errors = [];
    let $823b8d03c72b8ec8$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
        $823b8d03c72b8ec8$var$errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    };
    const $823b8d03c72b8ec8$export$ebe081a8c9bf8176 = (sinkFunc)=>{
        $823b8d03c72b8ec8$var$push = sinkFunc;
        $823b8d03c72b8ec8$var$errors.forEach((e)=>{
            sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
        });
        $823b8d03c72b8ec8$var$errors.length = 0;
    };
    const $823b8d03c72b8ec8$var$handleError = (e)=>{
        if (e.error?.UFOhasCaught === undefined) try {
            if (e.error instanceof Error) $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
            else if (e.error) {
                const hint = JSON.stringify(e.error).slice(0, 50);
                $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
            } else if (e.message !== undefined) {
                const hint = e.message.slice(0, 50);
                $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
            }
            if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
        } catch (e) {}
    };
    const $823b8d03c72b8ec8$var$handlePromiseRejection = (e)=>{
        if (e.reason instanceof Error) $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
        else if (e.reason) try {
            const hint = JSON.stringify(e.reason).slice(0, 50);
            $823b8d03c72b8ec8$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } catch (e) {}
    };
    const $823b8d03c72b8ec8$var$setupUFOGlobalErrorHandler = ()=>{
        if ($823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler) {
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'error',
                listener: (e)=>$823b8d03c72b8ec8$var$handleError(e)
            });
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'unhandledrejection',
                listener: $823b8d03c72b8ec8$var$handlePromiseRejection
            });
            $823b8d03c72b8ec8$var$shouldInitilizeGlobalErrorHandler = false;
        }
    };
    var $823b8d03c72b8ec8$export$2e2bcd8739ae039 = $823b8d03c72b8ec8$var$setupUFOGlobalErrorHandler;
});
parcelRegister("eMLDH", function(module, exports) {
    $parcel$export(module.exports, "getCookie", ()=>$ac3a808b0083e4d0$export$4be65e66cfa2648a);
    var $eYli8 = parcelRequire("eYli8");
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    function $ac3a808b0083e4d0$export$4be65e66cfa2648a(key) {
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedGetCookie',
                attributes: {
                    cookieKey: key
                }
            });
            return key ? (0, ($parcel$interopDefault($eYli8))).get(key) : (0, ($parcel$interopDefault($eYli8))).get();
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedGetCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use get cookie. ${e.message || ''}`
            });
        }
    }
});
parcelRegister("aGNyr", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsClient", ()=>$7c84441faeb57073$export$fde53e78fd93a54d);
    $parcel$export(module.exports, "sendPackageOperationalEvent", ()=>$7c84441faeb57073$export$5bfe55348e7aebc1);
    $parcel$export(module.exports, "sendUIEvent", ()=>$7c84441faeb57073$export$1aecf263098db667);
    $parcel$export(module.exports, "sendScreenEvent", ()=>$7c84441faeb57073$export$22a3b1671f38a193);
    $parcel$export(module.exports, "sendTrackEvent", ()=>$7c84441faeb57073$export$1ba525b8a711eaac);
    var $buAWB;
    var $iZhen;
    var $VSDnB;
    var $9eaC8;
    var $cala7;
    var $cip7i;
    var $5VG7g;
    const $7c84441faeb57073$var$getEnvironment = ()=>{
        const { hostname: hostname } = window.location;
        if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, (0, parcelRequire("iZhen")).envType).STAGING;
        if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, (0, parcelRequire("iZhen")).envType).DEV;
        return (0, (0, parcelRequire("iZhen")).envType).PROD;
    };
    const $7c84441faeb57073$export$78d7c0236b4fece9 = (path)=>{
        let subPath = '';
        if (!path) return subPath;
        const checkPath = (match)=>{
            return new RegExp(`^${match}(/|$)`).test(String(path));
        };
        if (checkPath('/wiki')) subPath = '/wiki';
        if (checkPath('/jira')) subPath = '/jira';
        if (checkPath('/compass')) subPath = '/compass';
        if (checkPath('/canvas')) subPath = '/canvas';
        if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
        return subPath;
    };
    const $7c84441faeb57073$var$getProductFromDomain = (domain)=>{
        if (domain === 'https://trello.com') return 'trello';
        return null;
    };
    const $7c84441faeb57073$export$fce3dd735e04d566 = ()=>{
        const { origin: origin, pathname: pathname } = window.location;
        const productPath = $7c84441faeb57073$export$78d7c0236b4fece9(pathname);
        const domain = `${origin}${productPath}`;
        const product = $7c84441faeb57073$var$getProductFromDomain(domain) || productPath.slice(1);
        return {
            domain: domain,
            product: product
        };
    };
    const $7c84441faeb57073$var$decorateEventAttributes = (attributes)=>{
        var _getBscGlobalState$pr, _getBscGlobalState$pr2;
        const { domain: domain, product: product } = $7c84441faeb57073$export$fce3dd735e04d566();
        return {
            featureFlagOn: (0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls'),
            packageName: (0, parcelRequire("cip7i")).packageName,
            packageVersion: (0, parcelRequire("cip7i")).packageVersion,
            domain: domain,
            product: (_getBscGlobalState$pr = (_getBscGlobalState$pr2 = (0, (0, parcelRequire("9eaC8")).getBscGlobalState)().product) === null || _getBscGlobalState$pr2 === void 0 ? void 0 : _getBscGlobalState$pr2.toLowerCase()) !== null && _getBscGlobalState$pr !== void 0 ? _getBscGlobalState$pr : product,
            ...attributes && attributes
        };
    };
    const $7c84441faeb57073$export$fde53e78fd93a54d = (()=>{
        let instance;
        return ()=>{
            try {
                if (!instance && (0, (0, parcelRequire("9eaC8")).getBscGlobalState)().analyticsEnabled) instance = new (0, (0, parcelRequire("buAWB")).default)({
                    env: $7c84441faeb57073$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
            }
            if (!(0, (0, parcelRequire("9eaC8")).getBscGlobalState)().analyticsEnabled) return undefined;
            return instance;
        };
    })();
    function $7c84441faeb57073$export$5bfe55348e7aebc1(properties) {
        (0, (0, parcelRequire("5VG7g")).withAnalyticsEventSampling)(properties.action, ()=>{
            var _getAnalyticsClient;
            return (_getAnalyticsClient = $7c84441faeb57073$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
                source: 'package',
                actionSubject: 'package',
                action: properties.action,
                attributes: $7c84441faeb57073$var$decorateEventAttributes(properties.attributes)
            });
        });
    }
    function $7c84441faeb57073$export$1aecf263098db667(properties) {
        var _getAnalyticsClient2;
        (_getAnalyticsClient2 = $7c84441faeb57073$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendUIEvent({
            ...properties,
            attributes: $7c84441faeb57073$var$decorateEventAttributes(properties.attributes)
        });
    }
    function $7c84441faeb57073$export$22a3b1671f38a193(properties) {
        var _getAnalyticsClient3;
        (_getAnalyticsClient3 = $7c84441faeb57073$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 || _getAnalyticsClient3.sendScreenEvent({
            ...properties,
            attributes: $7c84441faeb57073$var$decorateEventAttributes(properties.attributes)
        });
    }
    function $7c84441faeb57073$export$1ba525b8a711eaac(properties) {
        var _getAnalyticsClient4;
        (_getAnalyticsClient4 = $7c84441faeb57073$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendTrackEvent({
            ...properties,
            attributes: $7c84441faeb57073$var$decorateEventAttributes(properties.attributes)
        });
    }
});
parcelRegister("9eaC8", function(module, exports) {
    $parcel$export(module.exports, "getBscGlobalState", ()=>$6b7da79433bf01ea$export$3b78a1ea01f5ec28);
    $parcel$export(module.exports, "initializeGlobalState", ()=>$6b7da79433bf01ea$export$882c4530c58781d8);
    let $6b7da79433bf01ea$var$localAnalyticsEnabled;
    let $6b7da79433bf01ea$var$localProduct;
    let $6b7da79433bf01ea$var$webStorageControlsEnabled;
    const $6b7da79433bf01ea$export$3b78a1ea01f5ec28 = ()=>{
        if ($6b7da79433bf01ea$var$localAnalyticsEnabled == null) $6b7da79433bf01ea$var$localAnalyticsEnabled = true;
        return {
            analyticsEnabled: $6b7da79433bf01ea$var$localAnalyticsEnabled,
            product: $6b7da79433bf01ea$var$localProduct,
            webStorageEnabled: $6b7da79433bf01ea$var$webStorageControlsEnabled
        };
    };
    const $6b7da79433bf01ea$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'NONE', webStorageEnabled: webStorageEnabled = false } = {})=>{
        $6b7da79433bf01ea$var$localAnalyticsEnabled = analyticsEnabled;
        $6b7da79433bf01ea$var$localProduct = product;
        $6b7da79433bf01ea$var$webStorageControlsEnabled = webStorageEnabled;
    };
    const $6b7da79433bf01ea$export$ac7c2edd09656c05 = ()=>{
        $6b7da79433bf01ea$var$localAnalyticsEnabled = undefined;
        $6b7da79433bf01ea$var$localProduct = undefined;
    };
});
parcelRegister("cala7", function(module, exports) {
    $parcel$export(module.exports, "Logger", ()=>$8db6d5951661ef5d$export$efa9a398d6368992);
    var $aGNyr;
    const $8db6d5951661ef5d$var$LOG_PREFIX = '[browser-storage-controls]';
    class $8db6d5951661ef5d$export$efa9a398d6368992 {
        static info(message, metadata) {
            console.log(`${$8db6d5951661ef5d$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
        static error(message, metadata) {
            console.error(`${$8db6d5951661ef5d$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
        static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
            try {
                (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                    action: action,
                    attributes: {
                        error: message,
                        ...attributes
                    }
                });
            } catch (e) {
                this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
            }
            this.error(message, metadata ? JSON.stringify(metadata) : '');
        }
        static warn(message, metadata) {
            console.warn(`${$8db6d5951661ef5d$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
    }
});
parcelRegister("cip7i", function(module, exports) {
    $parcel$export(module.exports, "packageName", ()=>$8f3aa61eec6528d8$export$9345d7360ffe0722);
    $parcel$export(module.exports, "packageVersion", ()=>$8f3aa61eec6528d8$export$91546b032799aa40);
    var $6cAn5 = parcelRequire("6cAn5");
    var $8f3aa61eec6528d8$var$_ref, $8f3aa61eec6528d8$var$_process, $8f3aa61eec6528d8$var$_ref2, $8f3aa61eec6528d8$var$_process2;
    const $8f3aa61eec6528d8$export$9345d7360ffe0722 = ($8f3aa61eec6528d8$var$_ref = ($8f3aa61eec6528d8$var$_process = $6cAn5) === null || $8f3aa61eec6528d8$var$_process === void 0 ? void 0 : $8f3aa61eec6528d8$var$_process.env._PACKAGE_NAME_) !== null && $8f3aa61eec6528d8$var$_ref !== void 0 ? $8f3aa61eec6528d8$var$_ref : '';
    const $8f3aa61eec6528d8$export$91546b032799aa40 = ($8f3aa61eec6528d8$var$_ref2 = ($8f3aa61eec6528d8$var$_process2 = $6cAn5) === null || $8f3aa61eec6528d8$var$_process2 === void 0 ? void 0 : $8f3aa61eec6528d8$var$_process2.env._PACKAGE_VERSION_) !== null && $8f3aa61eec6528d8$var$_ref2 !== void 0 ? $8f3aa61eec6528d8$var$_ref2 : '';
});
parcelRegister("5VG7g", function(module, exports) {
    $parcel$export(module.exports, "withAnalyticsEventSampling", ()=>$4512f2015c59220a$export$67b6e87f323cb6ad);
    var $c9ZOU;
    var $3zdAw;
    var $8Ow66;
    const $4512f2015c59220a$export$1138592b3c099377 = {
        usedGetCookie: 100000,
        usedGetCookieError: 1,
        usedSetCookie: 1000,
        usedSetCookieError: 1,
        usedSetStrictlyNecessaryCookie: 10000,
        usedSetStrictlyNecessaryCookieError: 1,
        usedDeleteCookie: 10,
        usedDeleteCookieError: 1,
        usedCheckThirdParty: 100000,
        checkThirdPartyError: 1,
        usedDocumentCookie: 100,
        usedDocumentCookieError: 1,
        initializeControlsError: 1,
        loadStorageControlsError: 1,
        updatePreferencesError: 1,
        fetchConsentPreferencesError: 1,
        saveConsentPreferencesError: 1,
        usedAtlBrowserStorageGetItem: 100,
        usedAtlBrowserStorageGetItemError: 1,
        usedAtlBrowserStorageSetItem: 100,
        usedAtlBrowserStorageSetItemError: 1,
        usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
        usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
        usedCheckIfSetByPackageError: 1
    };
    const $4512f2015c59220a$var$localOnlySamplingKeys = [
        'loadStorageControlsError'
    ];
    async function $4512f2015c59220a$var$loadSamplingConfig() {
        if ((0, (0, parcelRequire("c9ZOU")).cache).cachedSamplingConfig) return (0, (0, parcelRequire("c9ZOU")).cache).cachedSamplingConfig;
        if ((0, (0, parcelRequire("3zdAw")).isSSR)()) return undefined;
        const controlsData = await (0, (0, parcelRequire("8Ow66")).loadStorageControlsData)();
        const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
        (0, (0, parcelRequire("c9ZOU")).cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
        return analyticsSamplingRatioConfigs;
    }
    async function $4512f2015c59220a$export$b286f5e8716d11ad(analyticsEventKey) {
        if ($4512f2015c59220a$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $4512f2015c59220a$export$1138592b3c099377[analyticsEventKey];
        const remoteSamplingConfig = await $4512f2015c59220a$var$loadSamplingConfig();
        const samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : $4512f2015c59220a$export$1138592b3c099377;
        const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $4512f2015c59220a$export$1138592b3c099377[analyticsEventKey];
        return samplingRatio;
    }
    function $4512f2015c59220a$export$dc2f0946255b3f89(samplingRatio, cb) {
        const shouldRun = !Math.floor(Math.random() * samplingRatio);
        shouldRun && cb();
    }
    async function $4512f2015c59220a$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
        const ratio = await $4512f2015c59220a$export$b286f5e8716d11ad(analyticsEventKey);
        $4512f2015c59220a$export$dc2f0946255b3f89(ratio, cb);
    }
});
parcelRegister("c9ZOU", function(module, exports) {
    $parcel$export(module.exports, "cache", ()=>$8da647774bb2b278$export$69a3209f1a06c04d);
    var $gSYbV;
    const $8da647774bb2b278$export$69a3209f1a06c04d = new (0, (0, parcelRequire("gSYbV")).CachedSamplingConfig)();
});
parcelRegister("gSYbV", function(module, exports) {
    $parcel$export(module.exports, "CachedSamplingConfig", ()=>$c4b0613efb9aad0f$export$b886edaf6623554a);
    class $c4b0613efb9aad0f$export$b886edaf6623554a {
        get cachedSamplingConfig() {
            return this.cache;
        }
        set cachedSamplingConfig(value) {
            this.cache = value;
        }
    }
});
parcelRegister("3zdAw", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$298f2e5025311e92$export$48d7c418edadb60c);
    var $buAWB;
    var $VSDnB;
    var $cala7;
    const $298f2e5025311e92$export$48d7c418edadb60c = ()=>{
        const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
        const isMissingBooleanFF = !(0, (0, parcelRequire("VSDnB")).fg);
        const isMissingAnalyticsWebClient = !Boolean((0, (0, parcelRequire("buAWB")).default));
        if (isMissingNecessaryBrowserUtils) (0, (0, parcelRequire("cala7")).Logger).warn('Browser context is not available.');
        if (isMissingBooleanFF) (0, (0, parcelRequire("cala7")).Logger).warn('Platform Feature Flag library is not available');
        if (!(0, (0, parcelRequire("buAWB")).default)) (0, (0, parcelRequire("cala7")).Logger).warn('analytics-web-client is not available');
        if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
        else return false;
    };
});
parcelRegister("8Ow66", function(module, exports) {
    $parcel$export(module.exports, "loadStorageControlsData", ()=>$66abe422e35b4c15$export$4dbb842f063ffea4);
    var $cala7;
    const $66abe422e35b4c15$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
    let $66abe422e35b4c15$var$localResponseCache;
    let $66abe422e35b4c15$var$localResponsePromiseCache;
    let $66abe422e35b4c15$var$localResponseJsonPromiseCache;
    const $66abe422e35b4c15$export$19bc72f5ccd901a6 = ()=>{
        $66abe422e35b4c15$var$localResponseCache = undefined;
        $66abe422e35b4c15$var$localResponsePromiseCache = undefined;
        $66abe422e35b4c15$var$localResponseJsonPromiseCache = undefined;
    };
    const $66abe422e35b4c15$var$handleCategoriesResponse = async (responsePromise)=>{
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        $66abe422e35b4c15$var$localResponseJsonPromiseCache = $66abe422e35b4c15$var$localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return $66abe422e35b4c15$var$localResponseJsonPromiseCache;
    };
    const $66abe422e35b4c15$export$4dbb842f063ffea4 = async ()=>{
        if ($66abe422e35b4c15$var$localResponseCache) return $66abe422e35b4c15$var$localResponseCache;
        else try {
            if (!$66abe422e35b4c15$var$localResponsePromiseCache) $66abe422e35b4c15$var$localResponsePromiseCache = fetch($66abe422e35b4c15$export$ab0619f627170401);
            $66abe422e35b4c15$var$localResponseCache = await $66abe422e35b4c15$var$handleCategoriesResponse($66abe422e35b4c15$var$localResponsePromiseCache);
            return $66abe422e35b4c15$var$localResponseCache;
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            $66abe422e35b4c15$export$19bc72f5ccd901a6();
        }
    };
});
parcelRegister("1u4q7", function(module, exports) {
    $parcel$export(module.exports, "DefaultInteractionID", ()=>$7e359588695aef0a$export$3109542b68df9ba1);
    $parcel$export(module.exports, "default", ()=>$7e359588695aef0a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getInteractionId", ()=>$7e359588695aef0a$export$37bca3107733ac1e);
    var $5uXOq = parcelRequire("5uXOq");
    const $7e359588695aef0a$export$3109542b68df9ba1 = {
        current: null
    };
    var $7e359588695aef0a$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($7e359588695aef0a$export$3109542b68df9ba1);
    const $7e359588695aef0a$export$37bca3107733ac1e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;
    const $7e359588695aef0a$export$9f6000531b78127e = ()=>$7e359588695aef0a$export$3109542b68df9ba1;
});
parcelRegister("bFU4G", function(module, exports) {
    $parcel$export(module.exports, "postInteractionLog", ()=>$b98c15df5ed39925$export$d8f52e8f804021e8);
    $parcel$export(module.exports, "getActiveInteraction", ()=>$b98c15df5ed39925$export$2b3954d2e8509985);
    $parcel$export(module.exports, "updatePageLoadInteractionName", ()=>$b98c15df5ed39925$export$f6f1cf5bedf83c71);
    $parcel$export(module.exports, "addMetadata", ()=>$b98c15df5ed39925$export$12f2b6cb85d59904);
    $parcel$export(module.exports, "addCustomData", ()=>$b98c15df5ed39925$export$e4380431c2bdabee);
    $parcel$export(module.exports, "addCustomTiming", ()=>$b98c15df5ed39925$export$27cacb7d7f3fe20a);
    $parcel$export(module.exports, "addMark", ()=>$b98c15df5ed39925$export$728e28c22a0fba4);
    $parcel$export(module.exports, "addSpan", ()=>$b98c15df5ed39925$export$2c1d6e17cfa9bbc7);
    $parcel$export(module.exports, "addSpanToAll", ()=>$b98c15df5ed39925$export$943a8b2b5d6b1809);
    $parcel$export(module.exports, "extractModuleName", ()=>$b98c15df5ed39925$export$f5a8f10de74904da);
    $parcel$export(module.exports, "addHold", ()=>$b98c15df5ed39925$export$7606887303596f82);
    $parcel$export(module.exports, "addHoldByID", ()=>$b98c15df5ed39925$export$10582acd678c213);
    $parcel$export(module.exports, "removeHoldByID", ()=>$b98c15df5ed39925$export$4983dfbbb996f7ae);
    $parcel$export(module.exports, "getCurrentInteractionType", ()=>$b98c15df5ed39925$export$2df109852219d16e);
    $parcel$export(module.exports, "ModuleLoadingProfiler", ()=>$b98c15df5ed39925$export$9591b52b33ccc510);
    $parcel$export(module.exports, "addError", ()=>$b98c15df5ed39925$export$239c33984d9b1367);
    $parcel$export(module.exports, "addErrorToAll", ()=>$b98c15df5ed39925$export$7379c15afd3840fa);
    $parcel$export(module.exports, "addProfilerTimings", ()=>$b98c15df5ed39925$export$53d6f611de951a13);
    $parcel$export(module.exports, "sinkInteractionHandler", ()=>$b98c15df5ed39925$export$9e614a29a1ac213e);
    $parcel$export(module.exports, "sinkPostInteractionLogHandler", ()=>$b98c15df5ed39925$export$8a1ba7bef607358a);
    $parcel$export(module.exports, "tryComplete", ()=>$b98c15df5ed39925$export$673be905888f8839);
    $parcel$export(module.exports, "abort", ()=>$b98c15df5ed39925$export$5def58af4fd46132);
    $parcel$export(module.exports, "abortByNewInteraction", ()=>$b98c15df5ed39925$export$c4a545284f55edf2);
    $parcel$export(module.exports, "abortAll", ()=>$b98c15df5ed39925$export$614a7af2affc5dff);
    $parcel$export(module.exports, "addOnCancelCallback", ()=>$b98c15df5ed39925$export$7b9261a96cfe427b);
    $parcel$export(module.exports, "addNewInteraction", ()=>$b98c15df5ed39925$export$1a1ed1e1fdb2006b);
    $parcel$export(module.exports, "addBrowserMetricEvent", ()=>$b98c15df5ed39925$export$4a759336b50e86e3);
    $parcel$export(module.exports, "addApdexToAll", ()=>$b98c15df5ed39925$export$ad216cc25852d44b);
    $parcel$export(module.exports, "addApdex", ()=>$b98c15df5ed39925$export$35220fd6cdd1b731);
    $parcel$export(module.exports, "addRequestInfo", ()=>$b98c15df5ed39925$export$57d55b4569823d8f);
    $parcel$export(module.exports, "addSegment", ()=>$b98c15df5ed39925$export$1c43f9ac826b6462);
    $parcel$export(module.exports, "removeSegment", ()=>$b98c15df5ed39925$export$d0365e48b58231c3);
    $parcel$export(module.exports, "addRedirect", ()=>$b98c15df5ed39925$export$bbf14d79614d9818);
    $parcel$export(module.exports, "interactionSpans", ()=>$b98c15df5ed39925$export$6ce04c7ca6810a7e);
    $parcel$export(module.exports, "addCustomSpans", ()=>$b98c15df5ed39925$export$5342dcad19138a1c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5gx4p;
    var $fe1wc;
    var $tcn7E;
    var $gSA3s;
    var $1u4q7;
    var $a0hd6;
    var $45w2S;
    var $bJCAw;
    const $b98c15df5ed39925$var$PreviousInteractionLog = {
        name: undefined,
        isAborted: undefined
    };
    const $b98c15df5ed39925$export$d8f52e8f804021e8 = new (0, (0, parcelRequire("bJCAw")).default)();
    const $b98c15df5ed39925$var$interactionQueue = [];
    const $b98c15df5ed39925$var$segmentCache = new Map();
    const $b98c15df5ed39925$var$CLEANUP_TIMEOUT = 60000;
    const $b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
    const $b98c15df5ed39925$var$segmentObservers = [];
    function $b98c15df5ed39925$export$2b3954d2e8509985() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        if (!interactionId.current) return;
        return (0, (0, parcelRequire("45w2S")).default).get(interactionId.current);
    }
    function $b98c15df5ed39925$var$labelStackToString(labelStack, name) {
        const stack = [
            ...labelStack ?? []
        ];
        if (name) stack.push({
            name: name
        });
        return stack.map((l)=>l.name)?.join('/');
    }
    function $b98c15df5ed39925$var$labelStackToIdString(labelStack) {
        return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
    }
    function $b98c15df5ed39925$var$addSegmentObserver(observer) {
        $b98c15df5ed39925$var$segmentObservers.push(observer);
        for (const segmentInfo of $b98c15df5ed39925$var$segmentCache.values())observer.onAdd(segmentInfo);
    }
    function $b98c15df5ed39925$var$removeSegmentObserver(observer) {
        const index = $b98c15df5ed39925$var$segmentObservers.findIndex((obs)=>obs === observer);
        if (index !== -1) $b98c15df5ed39925$var$segmentObservers.splice(index, 1);
    }
    function $b98c15df5ed39925$export$cd7f480d6b8286c3(interactionId) {
        (0, (0, parcelRequire("45w2S")).default).delete(interactionId);
    }
    function $b98c15df5ed39925$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
        const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        interaction.ufoName = ufoName;
        interaction.routeName = routeName;
    }
    function $b98c15df5ed39925$export$12f2b6cb85d59904(interactionId, data) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) Object.keys(data).forEach((key)=>{
            interaction.metaData[key] = data[key];
        });
    }
    function $b98c15df5ed39925$export$e4380431c2bdabee(interactionId, labelStack, data) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) Object.keys(data).forEach((i)=>{
            interaction.customData.push({
                labelStack: labelStack,
                data: {
                    [i]: data[i]
                }
            });
        });
    }
    function $b98c15df5ed39925$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            interaction.customTimings.push({
                labelStack: labelStack,
                data: data
            });
            if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) for (const [key, timingData] of Object.entries(data)){
                const { startTime: startTime, endTime: endTime } = timingData;
                try {
                    performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                        start: startTime,
                        end: endTime
                    });
                } catch (e) {}
            }
        }
    }
    function $b98c15df5ed39925$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
            startTime: time
        });
    }
    function $b98c15df5ed39925$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
        (0, (0, parcelRequire("45w2S")).default).forEach((interaction)=>{
            interaction.marks.push({
                type: type,
                name: name,
                labelStack: labelStack,
                time: time
            });
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) performance.mark(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
            startTime: time
        });
    }
    function $b98c15df5ed39925$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            interaction.spans.push({
                type: type,
                name: name,
                labelStack: labelStack,
                start: start,
                end: end,
                size: size
            });
            if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
                performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
                    start: start,
                    end: end
                });
            } catch (e) {}
        }
    }
    function $b98c15df5ed39925$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
        (0, (0, parcelRequire("45w2S")).default).forEach((interaction)=>{
            interaction.spans.push({
                type: type,
                name: name,
                labelStack: labelStack,
                start: start,
                end: end,
                size: size
            });
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
            performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {}
    }
    function $b98c15df5ed39925$export$9e04fe1a58571ec(moduleId, timestamp) {
        $b98c15df5ed39925$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
    }
    function $b98c15df5ed39925$export$6f228d1fdc911d7(identifier, start, end) {
        $b98c15df5ed39925$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
    }
    const $b98c15df5ed39925$var$moduleLoadingRequests = {};
    function $b98c15df5ed39925$export$f5a8f10de74904da(input) {
        let result = input ?? '';
        result = result.replace(/^\.\/src\/packages\//, '');
        result = result.replace(/^\.\/node_modules\//, '');
        result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
        return result;
    }
    function $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, startTime) {
        if (!window.__CRITERION__?.addUFOHold) return;
        window.__CRITERION__.addUFOHold(id, $b98c15df5ed39925$var$labelStackToString(labelStack), name, startTime);
    }
    function $b98c15df5ed39925$var$removeHoldCriterion(id) {
        if (!window.__CRITERION__?.removeUFOHold) return;
        window.__CRITERION__.removeUFOHold(id);
    }
    function $b98c15df5ed39925$export$7606887303596f82(interactionId, labelStack, name) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        const id = (0, $7Jxgt.v4)();
        if (interaction != null) {
            const start = performance.now();
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start
            });
            $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
            return ()=>{
                const end = performance.now();
                if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
                    performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack, name)} [hold]`, {
                        start: start,
                        end: end
                    });
                } catch (e) {}
                $b98c15df5ed39925$var$removeHoldCriterion(id);
                const currentInteraction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
                const currentHold = interaction.holdActive.get(id);
                if (currentInteraction != null && currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
            };
        }
        return ()=>{};
    }
    function $b98c15df5ed39925$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            const start = performance.now();
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $b98c15df5ed39925$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{};
    }
    function $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, id) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            const end = performance.now();
            const currentInteraction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push({
                    ...currentHold,
                    end: end
                });
                interaction.holdActive.delete(id);
                $b98c15df5ed39925$var$removeHoldCriterion(id);
            }
        }
    }
    function $b98c15df5ed39925$export$2df109852219d16e(interactionId) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction) return interaction.type;
        return null;
    }
    const $b98c15df5ed39925$export$9591b52b33ccc510 = {
        onPreload (moduleId, _priority) {
            $b98c15df5ed39925$export$9e04fe1a58571ec($b98c15df5ed39925$export$f5a8f10de74904da(moduleId), performance.now());
        },
        onLoadStart (info) {
            const timeoutId = setTimeout(()=>{
                delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
            }, 30000);
            const request = {
                start: performance.now(),
                timeoutId: timeoutId
            };
            $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier] = request;
        },
        onLoadComplete (info) {
            const request = $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
            if (request) {
                clearTimeout(request.timeoutId);
                delete $b98c15df5ed39925$var$moduleLoadingRequests[info.identifier];
                $b98c15df5ed39925$export$6f228d1fdc911d7($b98c15df5ed39925$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
            }
        },
        placeholderFallBackMounted (id, moduleId) {
            const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
            const currentInteractionId = interactionId.current;
            $b98c15df5ed39925$export$10582acd678c213(currentInteractionId, [], moduleId, id);
        },
        placeholderFallBackUnmounted (id) {
            const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
            const currentInteractionId = interactionId.current;
            $b98c15df5ed39925$export$4983dfbbb996f7ae(currentInteractionId, id);
        }
    };
    function $b98c15df5ed39925$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            forcedError: forcedError
        });
    }
    function $b98c15df5ed39925$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
        (0, (0, parcelRequire("45w2S")).default).forEach((interaction)=>{
            interaction.errors.push({
                name: name,
                labelStack: labelStack,
                errorType: errorType,
                errorMessage: errorMessage,
                errorStack: errorStack
            });
        });
    }
    const $b98c15df5ed39925$export$53d6f611de951a13 = (interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime)=>{
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
            performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
                start: startTime,
                duration: actualDuration
            });
        } catch (e) {}
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) interaction.reactProfilerTimings.push({
            labelStack: labelStack,
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime
        });
        else if ((0, (0, parcelRequire("fe1wc")).getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
    };
    const $b98c15df5ed39925$var$pushToQueue = (id, data)=>{
        $b98c15df5ed39925$var$interactionQueue.push({
            id: id,
            data: data
        });
    };
    let $b98c15df5ed39925$var$handleInteraction = $b98c15df5ed39925$var$pushToQueue;
    function $b98c15df5ed39925$var$callCleanUpCallbacks(interaction) {
        interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
            cleanUpCallback();
        });
    }
    const $b98c15df5ed39925$var$finishInteraction = (id, data, endTime = performance.now())=>{
        data.end = endTime;
        try {
            performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
                start: data.start,
                end: data.end
            });
        } catch (e) {}
        if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, (0, parcelRequire("gSA3s")).currentFeatureFlagsAccessed));
        (0, (0, parcelRequire("tcn7E")).clearActiveTrace)();
        $b98c15df5ed39925$var$callCleanUpCallbacks(data);
        if ((0, (0, parcelRequire("fe1wc")).getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, (0, parcelRequire("a0hd6")).getVCObserver)().getVCRawData();
        $b98c15df5ed39925$export$cd7f480d6b8286c3(id);
        $b98c15df5ed39925$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
        $b98c15df5ed39925$var$PreviousInteractionLog.isAborted = data.abortReason != null;
        if (data.ufoName) $b98c15df5ed39925$var$handleInteraction(id, data);
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) {
            const profilerTimingMap = new Map();
            data.reactProfilerTimings.forEach((profilerTiming)=>{
                const labelStackId = $b98c15df5ed39925$var$labelStackToIdString(profilerTiming.labelStack);
                if (labelStackId) {
                    const timing = profilerTimingMap.get(labelStackId) ?? {
                        labelStack: profilerTiming.labelStack
                    };
                    timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                    timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                    profilerTimingMap.set(labelStackId, timing);
                }
            });
            try {
                for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$b98c15df5ed39925$var$labelStackToString(labelStack)} [segment_ttai]`, {
                    start: start,
                    end: end
                });
            } catch (e) {}
        }
        try {
            window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
                detail: data
            }));
        } catch (error) {}
    };
    const $b98c15df5ed39925$export$9e614a29a1ac213e = (sinkFn)=>{
        if ($b98c15df5ed39925$var$handleInteraction === $b98c15df5ed39925$var$pushToQueue) {
            $b98c15df5ed39925$var$handleInteraction = sinkFn;
            $b98c15df5ed39925$var$interactionQueue.forEach((interaction)=>{
                sinkFn(interaction.id, interaction.data);
            });
            $b98c15df5ed39925$var$interactionQueue.length = 0;
        }
    };
    const $b98c15df5ed39925$export$8a1ba7bef607358a = (sinkFn)=>{
        $b98c15df5ed39925$export$d8f52e8f804021e8.sinkHandler(sinkFn);
    };
    function $b98c15df5ed39925$export$673be905888f8839(interactionId, endTime) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            const noMoreHolds = interaction.holdActive.size === 0;
            if (noMoreHolds) {
                $b98c15df5ed39925$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, (0, parcelRequire("fe1wc")).getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            }
        }
    }
    function $b98c15df5ed39925$var$callCancelCallbacks(interaction) {
        interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
            cancelCallback();
        });
    }
    function $b98c15df5ed39925$export$5def58af4fd46132(interactionId, abortReason) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            $b98c15df5ed39925$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        }
    }
    function $b98c15df5ed39925$export$c4a545284f55edf2(interactionId, interactionName) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            $b98c15df5ed39925$var$callCancelCallbacks(interaction);
            interaction.abortReason = 'new_interaction';
            interaction.abortedByInteractionName = interactionName;
            $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        }
    }
    function $b98c15df5ed39925$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
        (0, (0, parcelRequire("45w2S")).default).forEach((interaction, interactionId)=>{
            const noMoreHolds = interaction.holdActive.size === 0;
            if (!noMoreHolds) {
                $b98c15df5ed39925$var$callCancelCallbacks(interaction);
                interaction.abortReason = abortReason;
                if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            }
            $b98c15df5ed39925$var$finishInteraction(interactionId, interaction);
        });
    }
    function $b98c15df5ed39925$export$7b9261a96cfe427b(id, cancelCallback) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(id);
        interaction?.cancelCallbacks.push(cancelCallback);
    }
    function $b98c15df5ed39925$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
        if ((0, (0, parcelRequire("fe1wc")).getConfig)()?.postInteractionLog?.enabled) $b98c15df5ed39925$export$d8f52e8f804021e8.reset();
        let previousTime = startTime;
        let timeoutTime = $b98c15df5ed39925$var$CLEANUP_TIMEOUT;
        const timerID = setTimeout(()=>{
            $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
        }, $b98c15df5ed39925$var$CLEANUP_TIMEOUT);
        function changeTimeout(newTime) {
            const currentTime = performance.now();
            const timeLeft = timeoutTime - (currentTime - previousTime);
            if (timeLeft < newTime) return;
            clearTimeout(this.timerID);
            const newTimerID = setTimeout(()=>{
                $b98c15df5ed39925$export$5def58af4fd46132(interactionId, 'timeout');
            }, newTime);
            timeoutTime = newTime;
            previousTime = currentTime;
            this.timerID = newTimerID;
        }
        const addFeatureFlagsToInteraction = (0, (0, parcelRequire("5gx4p")).default)((0, (0, parcelRequire("fe1wc")).getCapabilityRate)('feature_flag_access'));
        const metrics = {
            id: interactionId,
            start: startTime,
            end: 0,
            ufoName: ufoName,
            type: type,
            previousInteractionName: $b98c15df5ed39925$var$PreviousInteractionLog.name,
            isPreviousInteractionAborted: $b98c15df5ed39925$var$PreviousInteractionLog.isAborted === true,
            marks: [],
            customData: [],
            customTimings: [],
            spans: [],
            requestInfo: [],
            reactProfilerTimings: [],
            holdInfo: [],
            holdActive: new Map(),
            measureStart: performance.now(),
            rate: rate,
            cancelCallbacks: [],
            metaData: {},
            errors: [],
            apdex: [],
            labelStack: labelStack,
            routeName: routeName ?? ufoName,
            featureFlags: addFeatureFlagsToInteraction ? {
                prior: Object.fromEntries((0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed)),
                during: {}
            } : undefined,
            knownSegments: [],
            cleanupCallbacks: [],
            awaitReactProfilerCount: 0,
            redirects: [],
            timerID: timerID,
            changeTimeout: changeTimeout,
            trace: trace
        };
        if (addFeatureFlagsToInteraction) (0, (0, parcelRequire("gSA3s")).currentFeatureFlagsAccessed).clear();
        (0, (0, parcelRequire("45w2S")).default).set(interactionId, metrics);
        const segmentObserver = {
            onAdd (segment) {
                metrics.knownSegments.push(segment);
            },
            onRemove () {}
        };
        $b98c15df5ed39925$var$addSegmentObserver(segmentObserver);
        metrics.cleanupCallbacks.push(()=>{
            $b98c15df5ed39925$var$removeSegmentObserver(segmentObserver);
        });
        metrics.cleanupCallbacks.push(()=>{
            clearTimeout(metrics.timerID);
        });
        const awaitBM3TTIList = (0, (0, parcelRequire("fe1wc")).getAwaitBM3TTIList)();
        if (awaitBM3TTIList.includes(ufoName)) $b98c15df5ed39925$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
        if (type === 'transition') {
            (0, (0, parcelRequire("a0hd6")).getVCObserver)().start({
                startTime: startTime
            });
            $b98c15df5ed39925$export$d8f52e8f804021e8.startVCObserver({
                startTime: startTime
            });
        }
    }
    function $b98c15df5ed39925$export$4a759336b50e86e3(event) {
        const interaction = $b98c15df5ed39925$export$2b3954d2e8509985();
        if (interaction) {
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push(event);
            if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
                interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $b98c15df5ed39925$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
            }
        }
    }
    function $b98c15df5ed39925$export$ad216cc25852d44b(apdex) {
        (0, (0, parcelRequire("45w2S")).default).forEach((interaction, key)=>{
            interaction.apdex.push(apdex);
            try {
                performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                    start: apdex.startTime ?? interaction.start,
                    end: apdex.stopTime
                });
            } catch (e) {}
            if (interaction.type === 'page_load' || interaction.type === 'transition') {
                interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $b98c15df5ed39925$export$4983dfbbb996f7ae(key, interaction.ufoName);
            }
        });
    }
    function $b98c15df5ed39925$export$35220fd6cdd1b731(interactionId, apdexInfo) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            interaction.apdex.push(apdexInfo);
            try {
                performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                    start: apdexInfo.startTime ?? interaction.start,
                    end: apdexInfo.stopTime
                });
            } catch (e) {}
            if (interaction.type === 'page_load' || interaction.type === 'transition') {
                interaction.changeTimeout($b98c15df5ed39925$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $b98c15df5ed39925$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
            }
        }
    }
    function $b98c15df5ed39925$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) interaction.requestInfo.push({
            labelStack: labelStack,
            ...requestInfo
        });
    }
    function $b98c15df5ed39925$var$isSegmentLabel(obj) {
        return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
    }
    function $b98c15df5ed39925$var$getSegmentCacheKey(labelStack) {
        return labelStack.map((l)=>{
            if ($b98c15df5ed39925$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
            return l.name;
        }).join('|');
    }
    function $b98c15df5ed39925$export$1c43f9ac826b6462(labelStack) {
        const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
        const existingSegment = $b98c15df5ed39925$var$segmentCache.get(key);
        if (!existingSegment) {
            const segmentInfo = {
                labelStack: labelStack
            };
            $b98c15df5ed39925$var$segmentCache.set(key, segmentInfo);
            $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
                observer.onAdd(segmentInfo);
            });
        }
    }
    function $b98c15df5ed39925$export$d0365e48b58231c3(labelStack) {
        const key = $b98c15df5ed39925$var$getSegmentCacheKey(labelStack);
        const segmentInfo = $b98c15df5ed39925$var$segmentCache.get(key);
        if (segmentInfo) {
            $b98c15df5ed39925$var$segmentCache.delete(JSON.stringify(labelStack));
            $b98c15df5ed39925$var$segmentObservers.forEach((observer)=>{
                observer.onRemove(segmentInfo);
            });
        }
    }
    function $b98c15df5ed39925$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
        const interaction = (0, (0, parcelRequire("45w2S")).default).get(interactionId);
        if (interaction != null) {
            interaction.ufoName = nextUfoName;
            interaction.routeName = nextRouteName;
            interaction.redirects.push({
                fromInteractionName: fromUfoName,
                time: time
            });
            if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) {
                const prevRedirect = interaction.redirects.at(-2);
                try {
                    performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                        start: prevRedirect?.time ?? interaction.start,
                        end: time
                    });
                } catch (e) {}
            }
        }
    }
    const $b98c15df5ed39925$export$6ce04c7ca6810a7e = [];
    const $b98c15df5ed39925$var$defaultLabelStack = [
        {
            name: 'custom'
        }
    ];
    function $b98c15df5ed39925$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $b98c15df5ed39925$var$defaultLabelStack) {
        const customSpan = {
            type: 'custom',
            name: name,
            start: start,
            end: end,
            labelStack: labelStack,
            size: size
        };
        $b98c15df5ed39925$export$6ce04c7ca6810a7e.push(customSpan);
    }
});
parcelRegister("5gx4p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50f3dab3adc4e602$export$2e2bcd8739ae039);
    function $50f3dab3adc4e602$export$2e2bcd8739ae039(rate) {
        if (rate === 0) return false;
        else if (rate === 1) return true;
        else return Math.random() * rate <= 1;
    }
});
parcelRegister("fe1wc", function(module, exports) {
    $parcel$export(module.exports, "setUFOConfig", ()=>$884a08804b0d324c$export$10d6139a8fb42158);
    $parcel$export(module.exports, "getConfig", ()=>$884a08804b0d324c$export$44487a86467333c3);
    $parcel$export(module.exports, "getInteractionRate", ()=>$884a08804b0d324c$export$9466a8f085fa7d4e);
    $parcel$export(module.exports, "getPostInteractionRate", ()=>$884a08804b0d324c$export$1d459f020c06ae34);
    $parcel$export(module.exports, "getCapabilityRate", ()=>$884a08804b0d324c$export$29b9ffb14861a1d);
    $parcel$export(module.exports, "getTypingPerformanceTracingMethod", ()=>$884a08804b0d324c$export$7e32aae12bf9b50f);
    $parcel$export(module.exports, "getAwaitBM3TTIList", ()=>$884a08804b0d324c$export$2d311b3fd18dcab1);
    $parcel$export(module.exports, "getUfoNameOverrides", ()=>$884a08804b0d324c$export$4f4649ef27b6f5d6);
    $parcel$export(module.exports, "getDoNotAbortActivePressInteraction", ()=>$884a08804b0d324c$export$3c170167645a0eff);
    $parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", ()=>$884a08804b0d324c$export$d6dc9444bd15f70f);
    let $884a08804b0d324c$var$config;
    function $884a08804b0d324c$export$10d6139a8fb42158(newConfig) {
        $884a08804b0d324c$var$config = newConfig;
    }
    function $884a08804b0d324c$export$44487a86467333c3() {
        return $884a08804b0d324c$var$config;
    }
    function $884a08804b0d324c$export$9466a8f085fa7d4e(name, interactionKind) {
        try {
            if (!$884a08804b0d324c$var$config) return 0;
            const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $884a08804b0d324c$var$config;
            if (killswitch != null) {
                if (killswitch.includes(name)) return 0;
            }
            if (rates != null) {
                if (rates[name] != null) return rates[name];
            }
            if (rules != null) for(let i = 0; i < rules.length; i++){
                const rule = rules[i];
                const { test: test, rate: rate } = rule;
                if (test != null && rate != null) {
                    const regexp = new RegExp(test, 'ig');
                    if (regexp.test(name)) return rate;
                }
            }
            const isAutogenerated = name?.startsWith('auto-generated');
            if (isAutogenerated) {
                const rate = autoGeneratedRate;
                if (rate != null) return rate;
            }
            if (kind != null) {
                const rate = kind[interactionKind];
                if (rate != null) return rate;
            }
            return 0;
        } catch (e) {
            return 0;
        }
    }
    function $884a08804b0d324c$export$1d459f020c06ae34(name, interactionType) {
        try {
            if (!$884a08804b0d324c$var$config) return 0;
            const { postInteractionLog: postInteractionLog } = $884a08804b0d324c$var$config;
            if (!postInteractionLog?.enabled) return 0;
            if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
            if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
            return 0;
        } catch (e) {
            return 0;
        }
    }
    function $884a08804b0d324c$export$29b9ffb14861a1d(capability) {
        try {
            if (!$884a08804b0d324c$var$config) return 0;
            const { capability: capabilityRate } = $884a08804b0d324c$var$config;
            if (capabilityRate != null) {
                const rate = capabilityRate[capability];
                if (rate != null) return rate;
            }
            return 0;
        } catch  {
            return 0;
        }
    }
    const $884a08804b0d324c$var$validTypingMethods = [
        'timeout',
        'timeoutNoAlloc',
        'mutationObserver'
    ];
    function $884a08804b0d324c$export$7e32aae12bf9b50f() {
        const defaultMethod = 'timeout';
        try {
            if (!$884a08804b0d324c$var$config) return defaultMethod;
            const { typingMethod: typingMethod } = $884a08804b0d324c$var$config;
            if (typingMethod != null && $884a08804b0d324c$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
            else return defaultMethod;
        } catch (e) {
            return defaultMethod;
        }
    }
    function $884a08804b0d324c$export$2d311b3fd18dcab1() {
        try {
            if (!$884a08804b0d324c$var$config) return [];
            const { awaitBM3TTI: awaitBM3TTI } = $884a08804b0d324c$var$config;
            if (awaitBM3TTI != null) return awaitBM3TTI;
            else return [];
        } catch (e) {
            return [];
        }
    }
    function $884a08804b0d324c$export$e2ea675800536898() {
        try {
            if (!$884a08804b0d324c$var$config) return false;
            const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $884a08804b0d324c$var$config;
            if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
            else return false;
        } catch (e) {
            return false;
        }
    }
    function $884a08804b0d324c$export$525ba53ca98e9db() {
        try {
            if (!$884a08804b0d324c$var$config) return false;
            const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $884a08804b0d324c$var$config;
            if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
            else return false;
        } catch (e) {
            return false;
        }
    }
    function $884a08804b0d324c$export$4f4649ef27b6f5d6() {
        try {
            if (!$884a08804b0d324c$var$config) return undefined;
            const { ufoNameOverrides: ufoNameOverrides } = $884a08804b0d324c$var$config;
            if (ufoNameOverrides != null) return ufoNameOverrides;
            return undefined;
        } catch (e) {
            return undefined;
        }
    }
    function $884a08804b0d324c$export$3c170167645a0eff() {
        try {
            if (!$884a08804b0d324c$var$config) return undefined;
            const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $884a08804b0d324c$var$config;
            return doNotAbortActivePressInteraction;
        } catch (e) {
            return undefined;
        }
    }
    function $884a08804b0d324c$export$d6dc9444bd15f70f() {
        try {
            if (!$884a08804b0d324c$var$config) return undefined;
            const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $884a08804b0d324c$var$config;
            return doNotAbortActivePressInteractionOnTransition;
        } catch (e) {
            return undefined;
        }
    }
});
parcelRegister("a0hd6", function(module, exports) {
    $parcel$export(module.exports, "getVCObserver", ()=>$fa52152d064ec067$export$b3bc47985717b49e);
    var $h2sI1;
    let $fa52152d064ec067$var$instance = null;
    const $fa52152d064ec067$export$b3bc47985717b49e = (opts = {})=>{
        if ($fa52152d064ec067$var$instance === null) $fa52152d064ec067$var$instance = new (0, (0, parcelRequire("h2sI1")).VCObserver)(opts);
        return $fa52152d064ec067$var$instance;
    };
});
parcelRegister("h2sI1", function(module, exports) {
    $parcel$export(module.exports, "VCObserver", ()=>$8281afea1c2bf80e$export$1f70d263701b1d01);
    var $aceO8;
    var $epQcA;
    var $eZGsd;
    const $8281afea1c2bf80e$var$abortReason = {
        scroll: 'scroll',
        keypress: 'keypress',
        resize: 'resize',
        error: 'error'
    };
    const $8281afea1c2bf80e$var$UNUSED_SECTOR = 0;
    function $8281afea1c2bf80e$var$filterComponentsLog(log) {
        return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
                Number(timestamp),
                entries.map((entry)=>{
                    const { __debug__element: __debug__element, ...rest } = entry;
                    return rest;
                })
            ]));
    }
    class $8281afea1c2bf80e$export$1f70d263701b1d01 {
        static{
            this.VCParts = [
                '25',
                '50',
                '75',
                '80',
                '85',
                '90',
                '95',
                '98',
                '99'
            ];
        }
        constructor(options){
            this.abortReason = {
                reason: null,
                info: '',
                timestamp: -1,
                blocking: false
            };
            this.outOfBoundaryInfo = '';
            this.viewport = {
                w: 0,
                h: 0
            };
            this.arraySize = 0;
            this.componentsLog = {};
            this.vcRatios = {};
            this.active = false;
            this.totalTime = 0;
            this.startTime = 0;
            this._startMeasureTimestamp = -1;
            this.ssr = {
                reactRendered: -1
            };
            this.unbind = [];
            this.getAbortReasonInfo = ()=>{
                if (this.abortReason.reason === null) return null;
                const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
                return `${this.abortReason.reason}${info}`;
            };
            this.getVCRawData = ()=>{
                this.measureStart();
                if (!this.active) {
                    this.measureStop();
                    return null;
                }
                this.stop();
                const abortReasonInfo = this.getAbortReasonInfo();
                this.measureStop();
                return {
                    abortReasonInfo: abortReasonInfo,
                    abortReason: {
                        ...this.abortReason
                    },
                    heatmap: this.ssrInclusiveHeatmap,
                    oldHeatmap: this.heatmap,
                    outOfBoundaryInfo: this.outOfBoundaryInfo,
                    totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                    componentsLog: {
                        ...this.componentsLog
                    },
                    viewport: {
                        ...this.viewport
                    },
                    oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                    devToolsEnabled: this.devToolsEnabled,
                    ratios: this.vcRatios
                };
            };
            this.getVCResult = ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc })=>{
                const startTime = performance.now();
                const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
                const rawData = vc !== undefined ? vc : this.getVCRawData();
                if (rawData === null) return {};
                const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, oldHeatmap: oldHeatmap, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
                if (abortReasonInfo !== null && abortReason.blocking) {
                    try {
                        if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                    } catch (e) {}
                    return {
                        [`${fullPrefix}vc:state`]: false,
                        [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                        [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                    };
                }
                const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                    heatmap: heatmap,
                    ssr: ssr,
                    componentsLog: {
                        ...componentsLog
                    },
                    viewport: viewport
                });
                try {
                    if (!this.isPostInteraction) $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                        const duration = VC[key];
                        if (duration !== null && duration !== undefined) performance.measure(`VC${key}`, {
                            start: start,
                            duration: duration
                        });
                    });
                } catch (e) {}
                const ssrVC = $8281afea1c2bf80e$export$1f70d263701b1d01.calculateVC({
                    heatmap: oldHeatmap,
                    ssr: ssr,
                    componentsLog: {
                        ...componentsLog
                    },
                    viewport: viewport
                });
                const outOfBoundary = outOfBoundaryInfo ? {
                    [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
                } : {};
                const stopTime = performance.now();
                try {
                    if (!this.isPostInteraction && devToolsEnabled) {
                        window.__vc = {
                            entries: VCEntries.rel,
                            log: componentsLog,
                            metrics: {
                                '75': VC['75'],
                                '80': VC['80'],
                                '85': VC['85'],
                                '90': VC['90'],
                                '95': VC['95'],
                                '98': VC['98'],
                                '99': VC['99'],
                                tti: tti,
                                ttai: stop - start
                            },
                            heatmap: heatmap,
                            ratios: ratios
                        };
                        window.dispatchEvent(new CustomEvent('vcReady', {
                            detail: {
                                log: $8281afea1c2bf80e$var$filterComponentsLog(componentsLog),
                                entries: VCEntries.rel
                            }
                        }));
                    }
                } catch (e) {}
                return {
                    'metrics:vc': VC,
                    [`${fullPrefix}vc:state`]: true,
                    [`${fullPrefix}vc:clean`]: !abortReasonInfo,
                    [`${fullPrefix}vc:dom`]: VCBox,
                    [`${fullPrefix}vc:updates`]: VCEntries.rel.slice(0, 50),
                    [`${fullPrefix}vc:size`]: viewport,
                    [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                    [`${fullPrefix}vc:total`]: totalPainted,
                    [`${fullPrefix}vc:ratios`]: ratios,
                    ...outOfBoundary,
                    [`${fullPrefix}vc:attrs`]: ssrVC.VC,
                    [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog)
                };
            };
            this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason)=>{
                this.measureStart();
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    const time = Math.round(rawTime - this.startTime);
                    const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                    this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                    if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                    if (!ignoreReason && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.ssrInclusiveHeatmap);
                    if (!this.componentsLog[time]) this.componentsLog[time] = [];
                    this.componentsLog[time].push({
                        __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                        intersectionRect: intersectionRect,
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    });
                }
                this.measureStop();
            };
            this.mapPixelsToHeatmap = (left, top, width, height)=>{
                const { w: w, h: h } = this.viewport;
                const l = Math.floor(left / w * this.arraySize);
                const t = Math.floor(top / h * this.arraySize);
                const r = Math.ceil((left + width) / w * this.arraySize);
                const b = Math.ceil((top + height) / h * this.arraySize);
                if (this.outOfBoundaryInfo === '') {
                    let outOfBoundaryInfo = '';
                    if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                    if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                    this.outOfBoundaryInfo = outOfBoundaryInfo;
                }
                const result = {
                    l: Math.max(0, l),
                    t: Math.max(0, t),
                    r: Math.min(this.arraySize, r),
                    b: Math.min(this.arraySize, b)
                };
                return result;
            };
            this.getElementRatio = (mappedValues)=>{
                const { r: r, l: l, b: b, t: t } = mappedValues;
                return (r - l) * (b - t) / (this.arraySize * this.arraySize);
            };
            this.abortReasonCallback = (key, time)=>{
                switch(key){
                    case 'wheel':
                        this.setAbortReason($8281afea1c2bf80e$var$abortReason.scroll, time);
                        break;
                    case 'keydown':
                        this.setAbortReason($8281afea1c2bf80e$var$abortReason.keypress, time);
                        break;
                    case 'resize':
                        this.setAbortReason($8281afea1c2bf80e$var$abortReason.resize, time);
                        break;
                }
            };
            this.attachAbortListeners = ()=>{
                this.detachAbortListeners();
                let unbinds = (0, (0, parcelRequire("aceO8")).attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
                if (window?.__SSR_ABORT_LISTENERS__) {
                    Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                        if (time) this.abortReasonCallback(key, time);
                    });
                    unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                    delete window?.__SSR_ABORT_LISTENERS__;
                }
                this.unbind = unbinds;
            };
            this.arraySize = options.heatmapSize || 200;
            this.devToolsEnabled = options.devToolsEnabled || false;
            this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
            this.observers = new (0, (0, parcelRequire("eZGsd")).Observers)({
                selectorConfig: options.selectorConfig || {
                    id: false,
                    testId: false,
                    role: false,
                    className: true,
                    dataVC: true
                }
            });
            this.heatmap = this.getCleanHeatmap();
            this.ssrInclusiveHeatmap = this.getCleanHeatmap();
            this.isPostInteraction = options.isPostInteraction || false;
        }
        start({ startTime: startTime }) {
            this.active = true;
            if (this.observers.isBrowserSupported()) {
                this.setViewportSize();
                this.resetState();
                this.startTime = startTime;
                this.attachAbortListeners();
                this.observers.subscribeResults(this.handleUpdate);
                this.observers.observe();
            } else this.setAbortReason('not-supported', startTime);
        }
        stop() {
            this.observers.disconnect();
            this.detachAbortListeners();
        }
        getIgnoredElements(componentsLog) {
            return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                    targetName: targetName,
                    ignoreReason: ignoreReason
                }));
        }
        static calculateVC({ heatmap: heatmap, ssr: ssr = $8281afea1c2bf80e$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
            const lastUpdate = {};
            let totalPainted = 0;
            if (ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR) {
                const element = {
                    __debug__element: new WeakRef(window.document?.body),
                    intersectionRect: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        x: 0,
                        y: 0,
                        width: viewport.w,
                        height: viewport.h,
                        toJSON () {
                            return {};
                        }
                    },
                    targetName: 'SSR'
                };
                if (!componentsLog[ssr]) componentsLog[ssr] = [];
                componentsLog[ssr].push(element);
            }
            heatmap.forEach((line)=>{
                line.forEach((entry)=>{
                    const rounded = Math.floor(entry === $8281afea1c2bf80e$var$UNUSED_SECTOR && ssr !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? ssr : entry);
                    totalPainted += rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR ? 1 : 0;
                    if (rounded !== $8281afea1c2bf80e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                });
            });
            const entries = Object.entries(lastUpdate).map((a)=>[
                    parseInt(a[0], 10),
                    a[1]
                ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
            const VC = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
            const VCBox = $8281afea1c2bf80e$export$1f70d263701b1d01.makeVCReturnObj();
            entries.reduce((acc = 0, v)=>{
                const VCRatio = v[1] / totalPainted + acc;
                const time = v[0];
                $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    const value = parseInt(key, 10);
                    if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                        VC[key] = time;
                        VCBox[key] = componentsLog[time]?.map((v)=>v.targetName);
                    }
                });
                return VCRatio;
            }, 0);
            const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
                const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
                const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                const logEntry = componentsLog[timestamp]?.map((v)=>v.targetName);
                acc.abs.push([
                    timestamp,
                    currentlyPainted
                ]);
                acc.rel.push({
                    time: timestamp,
                    vc: currentlyPaintedRatio,
                    elements: logEntry
                });
                return acc;
            }, {
                abs: [],
                rel: []
            });
            return {
                VC: VC,
                VCBox: VCBox,
                VCEntries: VCEntries,
                totalPainted: totalPainted
            };
        }
        setSSRElement(element) {
            this.observers.setReactRootElement(element);
        }
        setReactRootRenderStart(startTime = performance.now()) {
            this.observers.setReactRootRenderStart(startTime);
        }
        setReactRootRenderStop(stopTime = performance.now()) {
            this.observers.setReactRootRenderStop(stopTime);
        }
        setAbortReason(abort, timestamp, info = '') {
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                this.abortReason.reason = abort;
                this.abortReason.info = info;
                this.abortReason.timestamp = timestamp;
                this.abortReason.blocking = abort !== $8281afea1c2bf80e$var$abortReason.scroll;
                if (this.abortReason.blocking) this.detachAbortListeners();
            }
        }
        resetState() {
            this.abortReason = {
                reason: null,
                info: '',
                timestamp: -1,
                blocking: false
            };
            this.detachAbortListeners();
            this.heatmap = this.getCleanHeatmap();
            this.ssrInclusiveHeatmap = this.getCleanHeatmap();
            this.totalTime = 0;
            this.componentsLog = {};
            this.vcRatios = {};
        }
        getCleanHeatmap() {
            return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($8281afea1c2bf80e$var$UNUSED_SECTOR));
        }
        setViewportSize() {
            this.viewport.w = (0, (0, parcelRequire("epQcA")).getViewportWidth)();
            this.viewport.h = (0, (0, parcelRequire("epQcA")).getViewportHeight)();
        }
        applyChangesToHeatMap(a, time, heatmap) {
            const { l: l, t: t, r: r, b: b } = a;
            const localHeatmap = heatmap;
            for(let row = t; row < b; row++){
                for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                    try {
                        this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, `index - ${row}`);
                    } catch (e) {
                        this.setAbortReason($8281afea1c2bf80e$var$abortReason.error, time, 'row error');
                    }
                    return;
                } else localHeatmap[row][col] = time;
            }
        }
        static makeVCReturnObj() {
            const vc = {};
            $8281afea1c2bf80e$export$1f70d263701b1d01.VCParts.forEach((v)=>{
                vc[v] = null;
            });
            return vc;
        }
        detachAbortListeners() {
            this.unbind.forEach((fn)=>fn());
            this.unbind = [];
        }
        measureStart() {
            this._startMeasureTimestamp = performance.now();
        }
        measureStop() {
            if (this._startMeasureTimestamp === -1) return;
            this.totalTime += performance.now() - this._startMeasureTimestamp;
            this._startMeasureTimestamp = -1;
        }
    }
});
parcelRegister("aceO8", function(module, exports) {
    $parcel$export(module.exports, "attachAbortListeners", ()=>$05d54f94441303a8$export$9010aa71841a6887);
    var $cBeZP;
    var $Pu2vb;
    var $epQcA;
    const $05d54f94441303a8$export$9010aa71841a6887 = (window, initialViewPort, callback)=>{
        const unbindWheel = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("Pu2vb")).AbortEvent).wheel,
            listener: (e)=>{
                callback((0, (0, parcelRequire("Pu2vb")).AbortEvent).wheel, e.timeStamp);
            },
            options: {
                passive: true,
                once: true
            }
        });
        const unbindKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("Pu2vb")).AbortEvent).keydown,
            listener: (e)=>{
                callback((0, (0, parcelRequire("Pu2vb")).AbortEvent).keydown, e.timeStamp);
            },
            options: {
                once: true
            }
        });
        const unbindResize = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("Pu2vb")).AbortEvent).resize,
            listener: (e)=>{
                if ((0, (0, parcelRequire("epQcA")).getViewportWidth)() !== initialViewPort.w || (0, (0, parcelRequire("epQcA")).getViewportHeight)() !== initialViewPort.h) {
                    callback((0, (0, parcelRequire("Pu2vb")).AbortEvent).resize, e.timeStamp);
                    unbindResize();
                }
            }
        });
        return [
            unbindWheel,
            unbindKeydown,
            unbindResize
        ];
    };
});
parcelRegister("Pu2vb", function(module, exports) {
    $parcel$export(module.exports, "AbortEvent", ()=>$b4a560c0776083f4$export$199edc0307b5587f);
    const $b4a560c0776083f4$export$199edc0307b5587f = {
        wheel: 'wheel',
        keydown: 'keydown',
        resize: 'resize'
    };
});
parcelRegister("epQcA", function(module, exports) {
    $parcel$export(module.exports, "getViewportWidth", ()=>$20743fc2a72ae229$export$a497a1dcb4408212);
    $parcel$export(module.exports, "getViewportHeight", ()=>$20743fc2a72ae229$export$4f01c15d21ef9cc6);
    function $20743fc2a72ae229$export$a497a1dcb4408212(document = window.document) {
        let documentWidth;
        try {
            documentWidth = document.documentElement.clientWidth || 0;
        } catch (e) {
            documentWidth = 0;
        }
        return Math.max(documentWidth, window.innerWidth || 0);
    }
    function $20743fc2a72ae229$export$4f01c15d21ef9cc6(document = window.document) {
        let documentHeight;
        try {
            documentHeight = document.documentElement.clientHeight || 0;
        } catch (e) {
            documentHeight = 0;
        }
        return Math.max(documentHeight, window.innerHeight || 0);
    }
});
parcelRegister("eZGsd", function(module, exports) {
    $parcel$export(module.exports, "Observers", ()=>$aa3fefb78ef7f562$export$b65d046240060e78);
    var $1HYUt;
    var $flJpT;
    const $aa3fefb78ef7f562$var$state = {
        normal: 1,
        waitingForFirstRender: 2,
        ignoring: 3
    };
    class $aa3fefb78ef7f562$export$b65d046240060e78 {
        constructor(opts){
            this.observedMutations = new WeakMap();
            this.elementsInView = new Set();
            this.callbacks = new Set();
            this.totalTime = 0;
            this._startMeasureTimestamp = -1;
            this.ssr = {
                state: $aa3fefb78ef7f562$var$state.normal,
                reactRootElement: null,
                renderStart: -1,
                renderStop: -1
            };
            this.selectorConfig = {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            };
            this.subscribeResults = (cb)=>{
                this.callbacks.add(cb);
            };
            this.observeElement = (node, mutation, type, ignoreReason)=>{
                this.intersectionObserver?.observe(node);
                this.observedMutations.set(node, {
                    mutation: mutation,
                    ignoreReason: ignoreReason,
                    type: type
                });
            };
            this.selectorConfig = {
                ...this.selectorConfig,
                ...opts.selectorConfig
            };
            this.intersectionObserver = this.getIntersectionObserver();
            this.mutationObserver = this.getMutationObserver();
            this.ssrPlaceholderHandler = new (0, (0, parcelRequire("flJpT")).SSRPlaceholderHandlers)();
        }
        isBrowserSupported() {
            return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
        }
        observe() {
            this.totalTime = 0;
            this.ssr = {
                state: $aa3fefb78ef7f562$var$state.normal,
                reactRootElement: null,
                renderStart: -1,
                renderStop: -1
            };
            this.mutationObserver?.observe(document.body, {
                attributeFilter: [
                    'hidden',
                    'style',
                    'src'
                ],
                attributeOldValue: true,
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        disconnect() {
            this.mutationObserver?.disconnect();
            this.intersectionObserver?.disconnect();
            this.observedMutations = new WeakMap();
            this.elementsInView = new Set();
            this.callbacks = new Set();
            this.ssr.reactRootElement = null;
            this.ssrPlaceholderHandler.clear();
        }
        getTotalTime() {
            return this.totalTime;
        }
        setReactRootElement(element) {
            this.ssr.reactRootElement = element;
        }
        setReactRootRenderStart(startTime = performance.now()) {
            this.ssr.renderStart = startTime;
            this.ssr.state = $aa3fefb78ef7f562$var$state.waitingForFirstRender;
        }
        setReactRootRenderStop(stopTime = performance.now()) {
            this.ssr.renderStop = stopTime;
        }
        getMutationObserver() {
            return this.isBrowserSupported() ? new MutationObserver((mutations)=>{
                this.measureStart();
                mutations.forEach((mutation)=>{
                    mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                    let ignoreReason = '';
                    if (this.ssr.state === $aa3fefb78ef7f562$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                        this.ssr.state = $aa3fefb78ef7f562$var$state.ignoring;
                        if (this.ssr.renderStop === -1) this.ssr.renderStop = mutation.timestamp + 500;
                        ignoreReason = 'ssr-hydration';
                    }
                    if (this.ssr.state === $aa3fefb78ef7f562$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                        if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                        else this.ssr.state = $aa3fefb78ef7f562$var$state.normal;
                    }
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node)=>{
                            if ((0, (0, parcelRequire("1HYUt")).isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                            if (node instanceof HTMLElement) {
                                if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                    this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                        if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                    });
                                    return;
                                }
                                if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                    this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                        if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                    });
                                    return;
                                }
                                this.observeElement(node, mutation, 'html', ignoreReason);
                            }
                            if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                        });
                        mutation.removedNodes.forEach((node)=>{
                            if (node instanceof Element) {
                                this.elementsInView.delete(node);
                                this.intersectionObserver?.unobserve(node);
                            }
                        });
                    } else if (mutation.type === 'attributes') {
                        if (mutation.target instanceof HTMLElement) {
                            if (mutation.attributeName === 'style' && this.getStyleDisplay(mutation.target.getAttribute('style')) !== this.getStyleDisplay(mutation.oldValue)) this.observeElement(mutation.target, mutation, 'attr', ignoreReason);
                        }
                    }
                });
                this.measureStop();
            }) : null;
        }
        getStyleDisplay(styleAttributeValue) {
            if (!styleAttributeValue) return undefined;
            const declarations = styleAttributeValue.split(';');
            for (const declaration of declarations){
                const [property, value] = declaration.split(':').map((part)=>part.trim());
                if (property && property.toLowerCase() === 'display') return value;
            }
            return undefined;
        }
        getElementName(element) {
            try {
                const tagName = element.localName;
                const dataVCAttr = element.getAttribute('data-vc');
                const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
                const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
                let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                testId = testId ? `[testid=${testId}]` : '';
                let role = this.selectorConfig.role ? element.getAttribute('role') : '';
                role = role ? `[role=${role}]` : '';
                let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                classList = classList === '' ? '' : `.${classList}`;
                const attrs = dataVC ? dataVC : [
                    id,
                    testId,
                    role
                ].join('');
                let idString = '';
                if (attrs === '' && classList === '') {
                    const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                    idString = `${parent} > ${tagName}`;
                } else idString = [
                    tagName,
                    attrs || classList
                ].join('');
                return idString;
            } catch (e) {
                return 'error';
            }
        }
        getIntersectionObserver() {
            return this.isBrowserSupported() ? new IntersectionObserver((entries)=>{
                this.measureStart();
                entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                    const data = this.observedMutations.get(target);
                    this.observedMutations.delete(target);
                    if (isIntersecting && ir.width > 0 && ir.height > 0) {
                        if (!(target instanceof HTMLElement)) return;
                        if (!data?.mutation) return;
                        this.callbacks.forEach((callback)=>{
                            let elementName;
                            try {
                                elementName = this.getElementName(target);
                            } catch (e) {
                                elementName = 'error';
                            }
                            callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                        });
                        this.elementsInView.add(target);
                    } else this.elementsInView.delete(target);
                });
                this.measureStop();
            }) : null;
        }
        measureStart() {
            this._startMeasureTimestamp = performance.now();
        }
        measureStop() {
            if (this._startMeasureTimestamp === -1) return;
            this.totalTime += performance.now() - this._startMeasureTimestamp;
            this._startMeasureTimestamp = -1;
        }
    }
});
parcelRegister("1HYUt", function(module, exports) {
    $parcel$export(module.exports, "isContainedWithinMediaWrapper", ()=>$dac8a3c213f349f7$export$f61fbc3b9c4a9019);
    var $lr1Nm;
    const $dac8a3c213f349f7$export$f61fbc3b9c4a9019 = (node)=>{
        while(node){
            if (node instanceof Element && node.hasAttribute((0, (0, parcelRequire("lr1Nm")).MEDIA_WRAPPER_TAG))) return true;
            node = node.parentNode;
        }
        return false;
    };
});
parcelRegister("lr1Nm", function(module, exports) {
    $parcel$export(module.exports, "MEDIA_WRAPPER_TAG", ()=>$71e1e5daed4f23b4$export$7674290405cc25b0);
    $parcel$export(module.exports, "VcMediaWrapperProps", ()=>$71e1e5daed4f23b4$export$7028e9efe569888c);
    var $5uXOq = parcelRequire("5uXOq");
    const $71e1e5daed4f23b4$export$7674290405cc25b0 = 'data-media-vc-wrapper';
    const $71e1e5daed4f23b4$export$7028e9efe569888c = {
        [$71e1e5daed4f23b4$export$7674290405cc25b0]: true
    };
    function $71e1e5daed4f23b4$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", $71e1e5daed4f23b4$export$7028e9efe569888c, children);
    }
});
parcelRegister("flJpT", function(module, exports) {
    $parcel$export(module.exports, "SSRPlaceholderHandlers", ()=>$8867921f8b6036b7$export$c0102f1a1198d10f);
    const $8867921f8b6036b7$var$EQUALITY_THRESHOLD = 0.1;
    const $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT = 10;
    class $8867921f8b6036b7$export$c0102f1a1198d10f {
        constructor(){
            this.staticPlaceholders = new Map();
            this.callbacks = new Map();
            this.getSizeCallbacks = new Map();
            this.reactValidateCallbacks = new Map();
            this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
                this.intersectionObserver.unobserve(target);
                if (!(target instanceof HTMLElement)) return;
                const staticKey = target.dataset.ssrPlaceholder || '';
                if (staticKey) {
                    if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                        const resolve = this.callbacks.get(staticKey);
                        if (!resolve) return;
                        const rect = this.staticPlaceholders.get(staticKey);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                        resolve(hasSameSizePosition);
                        this.callbacks.delete(staticKey);
                    }
                } else {
                    const key = target.dataset.ssrPlaceholderReplace || '';
                    const resolve = this.reactValidateCallbacks.get(key);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(key);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    resolve(hasSameSizePosition);
                    this.staticPlaceholders.delete(staticKey);
                    this.reactValidateCallbacks.delete(staticKey);
                }
            };
            this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
            if (window.document) try {
                const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
                existingElements.forEach((el)=>{
                    if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                        let width = -1;
                        let height = -1;
                        let x = -1;
                        let y = -1;
                        const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[el.dataset.ssrPlaceholder];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        }
                        this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        this.intersectionObserver.observe(el);
                    }
                });
            } catch (e) {} finally{
                delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
            }
        }
        clear() {
            this.staticPlaceholders = new Map();
            this.callbacks = new Map();
            this.getSizeCallbacks = new Map();
            this.reactValidateCallbacks = new Map();
        }
        isPlaceholder(element) {
            return Boolean(element.dataset.ssrPlaceholder);
        }
        isPlaceholderReplacement(element) {
            return Boolean(element.dataset.ssrPlaceholderReplace);
        }
        isPlaceholderIgnored(element) {
            return 'ssrPlaceholderIgnored' in element.dataset;
        }
        findNearestPlaceholderContainerIfIgnored(element) {
            if (!this.isPlaceholderIgnored(element)) return element;
            let ancestor = element.parentElement;
            let i = 0;
            while(ancestor && i < $8867921f8b6036b7$var$ANCESTOR_LOOKUP_LIMIT){
                if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                ancestor = ancestor.parentElement;
                i++;
            }
            return element;
        }
        checkIfExistedAndSizeMatching(el) {
            el = this.findNearestPlaceholderContainerIfIgnored(el);
            const id = el.dataset.ssrPlaceholder || '';
            return new Promise((resolve)=>{
                if (!this.staticPlaceholders.has(id)) {
                    resolve(false);
                    return;
                } else {
                    this.callbacks.set(id, resolve);
                    this.intersectionObserver.observe(el);
                }
            });
        }
        getSize(el) {
            return new Promise((resolve)=>{
                this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
                this.intersectionObserver.observe(el);
            });
        }
        validateReactComponentMatchToPlaceholder(el) {
            el = this.findNearestPlaceholderContainerIfIgnored(el);
            const id = el.dataset.ssrPlaceholderReplace || '';
            return new Promise((resolve)=>{
                if (!this.staticPlaceholders.has(id)) {
                    resolve(false);
                    return;
                } else {
                    this.reactValidateCallbacks.set(id, resolve);
                    this.intersectionObserver.observe(el);
                }
            });
        }
        hasSameSizePosition(rect, boundingClientRect) {
            return rect && Math.abs(rect.x - boundingClientRect.x) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $8867921f8b6036b7$var$EQUALITY_THRESHOLD || false;
        }
    }
});
parcelRegister("45w2S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689164667c3e99b9$export$2e2bcd8739ae039);
    const $689164667c3e99b9$var$interactions = new Map();
    var $689164667c3e99b9$export$2e2bcd8739ae039 = $689164667c3e99b9$var$interactions;
});
parcelRegister("bJCAw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34ef004db30d88d6$export$2e2bcd8739ae039);
    var $fe1wc;
    var $h2sI1;
    const $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
    class $34ef004db30d88d6$export$2e2bcd8739ae039 {
        initializeVCObserver(options) {
            if (this.vcObserver === null) this.vcObserver = new (0, (0, parcelRequire("h2sI1")).VCObserver)({
                ...options,
                isPostInteraction: true
            });
        }
        startVCObserver({ startTime: startTime }) {
            this.vcObserver?.start({
                startTime: startTime
            });
        }
        setVCObserverSSRConfig(vcObserverSSRConfig) {
            this.vcObserverSSRConfig = vcObserverSSRConfig;
        }
        setLastInteractionFinishVCResult(result) {
            this.lastInteractionFinishVCResult = result;
        }
        sinkHandler(sinkHandlerFn) {
            this.sinkHandlerFn = sinkHandlerFn;
        }
        reset() {
            this.lastInteractionFinish = null;
            this.reactProfilerTimings = [];
            if (this.sinkTimeoutId != null) {
                clearTimeout(this.sinkTimeoutId);
                this.sinkTimeoutId = null;
            }
            this.setVCObserverSSRConfig(null);
        }
        hasData() {
            return this.reactProfilerTimings?.length > 0;
        }
        sendPostInteractionLog() {
            if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
                this.reset();
                return;
            }
            this.sinkHandlerFn({
                lastInteractionFinish: this.lastInteractionFinish,
                reactProfilerTimings: this.reactProfilerTimings,
                postInteractionFinishVCResult: this.vcObserver?.getVCResult({
                    start: this.lastInteractionFinish.start,
                    stop: performance.now(),
                    tti: -1,
                    prefix: 'ufo',
                    ...this.vcObserverSSRConfig
                }),
                lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
            });
            this.reset();
        }
        onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type }) {
            this.lastInteractionFinish = {
                ufoName: ufoName,
                start: start,
                end: end,
                id: id,
                abortReason: abortReason,
                abortedByInteractionName: abortedByInteractionName,
                routeName: routeName,
                type: type
            };
            const timeout = (0, (0, parcelRequire("fe1wc")).getConfig)()?.timeWindowForLateMutationsInMilliseconds || $34ef004db30d88d6$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
            this.sinkTimeoutId = window.setTimeout(()=>{
                this.sendPostInteractionLog();
            }, timeout);
        }
        addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
            if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                type: type,
                actualDuration: actualDuration,
                baseDuration: baseDuration,
                startTime: startTime,
                commitTime: commitTime,
                labelStack: labelStack
            });
        }
        constructor(){
            this.lastInteractionFinish = null;
            this.reactProfilerTimings = [];
            this.sinkTimeoutId = null;
            this.vcObserver = null;
            this.vcObserverSSRConfig = null;
            this.sinkHandlerFn = ()=>{};
        }
    }
});
parcelRegister("1tcYS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea2ed9c2ccea9583$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useInteractionContext", ()=>$ea2ed9c2ccea9583$export$11bcb6e9af2aca35);
    var $5uXOq = parcelRequire("5uXOq");
    var $6wxJn;
    var $ea2ed9c2ccea9583$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6wxJn")).default);
    function $ea2ed9c2ccea9583$export$11bcb6e9af2aca35() {
        return (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
    }
});
parcelRegister("21pfT", function(module, exports) {
    $parcel$export(module.exports, "browserMetrics", ()=>$41be1e74eab9e5f7$export$c08e7affcf78b064);
    var $Y0qGc;
    var $1a316;
    var $7cRo8;
    var $fCzt4;
    var $bC5TE;
    var $dNz07;
    var $9mLUv;
    var $2OjhD;
    const $41be1e74eab9e5f7$var$makeBrowserMetrics = ()=>{
        const bm = {
            init (config) {
                (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).start();
                if (config.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS]?.enabled) (0, (0, parcelRequire("bC5TE")).webVitalsObserver).start();
                if (config.debug) {
                    (0, (0, parcelRequire("1a316")).logger).enable();
                    (0, (0, parcelRequire("9mLUv")).submitter).setDebug(true);
                    (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).setDebug(true);
                }
                (0, (0, parcelRequire("9mLUv")).submitter).configure(config);
                if (config.ssr?.getDoneMark) (0, (0, parcelRequire("Y0qGc")).SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
            },
            setRoute (newRoute) {
                (0, (0, parcelRequire("dNz07")).Route).setRoute(newRoute);
            },
            startPageLoad (params) {
                (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).startPageLoad({
                    isInitial: false,
                    cancelStarted: true,
                    ...params
                });
            },
            getPageLoadMetric () {
                return 0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric;
            },
            experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
                if (initialOnly && !(0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).isInitialLoad()) return;
                const start = performance.getEntriesByName(startMark);
                const stop = performance.getEntriesByName(stopMark);
                if (start.length > 0 && stop.length > 0) {
                    if ((0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).isDebugMode()) try {
                        performance.measure(name, startMark, stopMark);
                    } catch (e) {}
                    const pageLoadData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getData();
                    if (pageLoadData.start !== null) {
                        const startMark = start[start.length - 1];
                        const timing = {
                            startTime: Math.round(startMark.startTime - pageLoadData.start),
                            duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                        };
                        (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                    }
                }
            }
        };
        return bm;
    };
    const $41be1e74eab9e5f7$export$c08e7affcf78b064 = $41be1e74eab9e5f7$var$makeBrowserMetrics();
});
parcelRegister("Y0qGc", function(module, exports) {
    $parcel$export(module.exports, "SSRGetDoneMark", ()=>$87294ec8a2d91847$export$9e87a201397ac0a9);
    const $87294ec8a2d91847$export$9e87a201397ac0a9 = {
        getDoneMark: ()=>null,
        setGetDoneMark: (fn)=>{
            $87294ec8a2d91847$export$9e87a201397ac0a9.getDoneMark = fn;
        }
    };
});
parcelRegister("1a316", function(module, exports) {
    $parcel$export(module.exports, "logger", ()=>$ce30b9b67753626e$export$af88d00dbe7f521);
    const $ce30b9b67753626e$export$af88d00dbe7f521 = {
        enabled: false,
        enable () {
            this.enabled = true;
        },
        log (...args) {
            if (this.enabled) console.log('BM log: ', ...args);
        },
        logCond (condition, ...args) {
            if (this.enabled && condition && args.length > 1) this.log(...args);
        }
    };
});
parcelRegister("7cRo8", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetaMetric", ()=>$eb7d2fead5730ef2$export$24b7a1a311eb05dc);
    var $2OjhD;
    var $faqZ3;
    var $hjsyZ;
    class $eb7d2fead5730ef2$export$9609608c00ea5077 extends (0, (0, parcelRequire("hjsyZ")).BasePageLoadMetric) {
        startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
            isInitial: false,
            cancelStarted: false
        }) {
            if (cancelStarted || this.state !== (0, (0, parcelRequire("faqZ3")).MetricState).STARTED) super.startPageLoad(startPageLoadParams);
        }
        setActive(metric) {
            this.activePageLoadMetric = metric;
        }
        setDebug(debug) {
            this.config.debug = debug;
        }
        isDebugMode() {
            return this.config.debug;
        }
        isInitialLoad() {
            return this.isInitial;
        }
        clear() {
            this.activePageLoadMetric && this.activePageLoadMetric.cancel();
            super.clear();
        }
        include(metric) {
            if (!this.config.include) this.config.include = [
                metric
            ];
            else this.config.include.push(metric);
        }
        experimental__addExplicitTiming(name, timing) {
            if (this.explicitTimings === null) this.explicitTimings = {};
            this.explicitTimings[name] = timing;
        }
        constructor(...args){
            super(...args);
            this.activePageLoadMetric = null;
        }
    }
    const $eb7d2fead5730ef2$export$24b7a1a311eb05dc = new $eb7d2fead5730ef2$export$9609608c00ea5077({
        type: (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD,
        key: 'page_load_meta_metric'
    });
});
parcelRegister("2OjhD", function(module, exports) {
    $parcel$export(module.exports, "BMEventsType", ()=>$b9090a2a775e8405$export$9c73e297d4be9159);
    $parcel$export(module.exports, "StorableBMEventsType", ()=>$b9090a2a775e8405$export$9b7037ec30489597);
    $parcel$export(module.exports, "BMPageLoadMetrics", ()=>$b9090a2a775e8405$export$74c1fb0997d51e2a);
    $parcel$export(module.exports, "BMPageSegmentLoadMetrics", ()=>$b9090a2a775e8405$export$88195ac8200d03a6);
    $parcel$export(module.exports, "BMInteractionMetrics", ()=>$b9090a2a775e8405$export$6e28252a002afdb2);
    $parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", ()=>$b9090a2a775e8405$export$474154836bfd8dd9);
    $parcel$export(module.exports, "PageVisibleFields", ()=>$b9090a2a775e8405$export$e89802082dab5633);
    $parcel$export(module.exports, "PageVisibleValueOrigin", ()=>$b9090a2a775e8405$export$983b017156c2aee2);
    $parcel$export(module.exports, "isDetailedPageLoadSlo", ()=>$b9090a2a775e8405$export$5866f95702a15142);
    $parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", ()=>$b9090a2a775e8405$export$f087a59bd717e49d);
    $parcel$export(module.exports, "isInteractionMetricsSlo", ()=>$b9090a2a775e8405$export$b10c1d9a7db7765b);
    $parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", ()=>$b9090a2a775e8405$export$60c0193054fc3040);
    var $faqZ3;
    var $b9090a2a775e8405$export$9c73e297d4be9159;
    (function(BMEventsType) {
        BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
        BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
        BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
        BMEventsType["CUSTOM"] = "CUSTOM";
        BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    })($b9090a2a775e8405$export$9c73e297d4be9159 || ($b9090a2a775e8405$export$9c73e297d4be9159 = {}));
    var $b9090a2a775e8405$export$9b7037ec30489597;
    (function(StorableBMEventsType) {
        StorableBMEventsType["PAGE_LOAD"] = "page-load";
        StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
        StorableBMEventsType["INLINE_RESULT"] = "inline-result";
        StorableBMEventsType["CUSTOM"] = "custom";
        StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    })($b9090a2a775e8405$export$9b7037ec30489597 || ($b9090a2a775e8405$export$9b7037ec30489597 = {}));
    var $b9090a2a775e8405$export$74c1fb0997d51e2a;
    (function(BMPageLoadMetrics) {
        BMPageLoadMetrics["fmp"] = "fmp";
        BMPageLoadMetrics["tti"] = "tti";
    })($b9090a2a775e8405$export$74c1fb0997d51e2a || ($b9090a2a775e8405$export$74c1fb0997d51e2a = {}));
    var $b9090a2a775e8405$export$88195ac8200d03a6;
    (function(BMPageSegmentLoadMetrics) {
        BMPageSegmentLoadMetrics["fmp"] = "fmp";
        BMPageSegmentLoadMetrics["tti"] = "tti";
    })($b9090a2a775e8405$export$88195ac8200d03a6 || ($b9090a2a775e8405$export$88195ac8200d03a6 = {}));
    var $b9090a2a775e8405$export$6e28252a002afdb2;
    (function(BMInteractionMetrics) {
        BMInteractionMetrics["response"] = "response";
        BMInteractionMetrics["result"] = "result";
    })($b9090a2a775e8405$export$6e28252a002afdb2 || ($b9090a2a775e8405$export$6e28252a002afdb2 = {}));
    var $b9090a2a775e8405$export$474154836bfd8dd9;
    (function(PageSegmentPageLoadMetricsOptions) {
        PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
        PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
        PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    })($b9090a2a775e8405$export$474154836bfd8dd9 || ($b9090a2a775e8405$export$474154836bfd8dd9 = {}));
    var $b9090a2a775e8405$export$e89802082dab5633;
    (function(PageVisibleFields) {
        PageVisibleFields["pageVisibleState"] = "page-visible-state";
        PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    })($b9090a2a775e8405$export$e89802082dab5633 || ($b9090a2a775e8405$export$e89802082dab5633 = {}));
    var $b9090a2a775e8405$export$983b017156c2aee2;
    (function(PageVisibleValueOrigin) {
        PageVisibleValueOrigin["documentHidden"] = "document-hidden";
        PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    })($b9090a2a775e8405$export$983b017156c2aee2 || ($b9090a2a775e8405$export$983b017156c2aee2 = {}));
    const $b9090a2a775e8405$export$5866f95702a15142 = (data)=>{
        return Boolean(data.initial);
    };
    const $b9090a2a775e8405$export$f087a59bd717e49d = (data)=>{
        return Boolean(data.initial);
    };
    const $b9090a2a775e8405$export$153c4c72fa5eeece = (data)=>{
        const obj = data;
        return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
    };
    const $b9090a2a775e8405$export$b10c1d9a7db7765b = (data)=>{
        const obj = data;
        return Boolean(obj.result !== undefined || obj.response !== undefined);
    };
    var $b9090a2a775e8405$export$60c0193054fc3040;
    (function(IncludeSSRFeatureFlagsConfig) {
        IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
        IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
        IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    })($b9090a2a775e8405$export$60c0193054fc3040 || ($b9090a2a775e8405$export$60c0193054fc3040 = {}));
});
parcelRegister("faqZ3", function(module, exports) {
    $parcel$export(module.exports, "MetricState", ()=>$d0da0e1fa3f8875a$export$1e458f18c0c7bfe3);
    $parcel$export(module.exports, "PageVisibleState", ()=>$d0da0e1fa3f8875a$export$a12c67b37a306b13);
    $parcel$export(module.exports, "BaseMetric", ()=>$d0da0e1fa3f8875a$export$2bce4ffdd840e878);
    var $bopkp;
    var $1a316;
    var $fCzt4;
    var $dNRIi;
    var $d0da0e1fa3f8875a$export$1e458f18c0c7bfe3;
    (function(MetricState) {
        MetricState["NOT_STARTED"] = "not-started";
        MetricState["STARTED"] = "started";
        MetricState["FINISHED"] = "finished";
        MetricState["CANCELLED"] = "cancelled";
    })($d0da0e1fa3f8875a$export$1e458f18c0c7bfe3 || ($d0da0e1fa3f8875a$export$1e458f18c0c7bfe3 = {}));
    var $d0da0e1fa3f8875a$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["MIXED"] = "mixed";
        PageVisibleState["HIDDEN"] = "hidden";
    })($d0da0e1fa3f8875a$export$a12c67b37a306b13 || ($d0da0e1fa3f8875a$export$a12c67b37a306b13 = {}));
    function $d0da0e1fa3f8875a$var$getPageVisibleState() {
        return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
    }
    class $d0da0e1fa3f8875a$export$2bce4ffdd840e878 {
        static{
            this.FMP = 'fmp';
        }
        constructor(config){
            this.state = "not-started";
            this.startTime = null;
            this.stopTime = null;
            this.marks = {};
            this.onStopCallbacks = [];
            this.custom = null;
            this.submetrics = [];
            this.route = null;
            this.untilOnStopCallback = null;
            this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = "mixed";
            };
            this.config = config;
            this.key = config.key.replace(/ /gi, '-');
            this.type = config.type;
            this.config.timings?.forEach((entry)=>{
                if ((0, (0, parcelRequire("bopkp")).restrictedTimingKeys).includes(entry.key)) {
                    console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                    entry.key = `custom__${entry.key}`;
                }
            });
        }
        get untilMetrics() {
            const { until: until } = this.config;
            if (!until) return [];
            else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
            return this.getConfiguredUntilMetricArray([
                until
            ]);
        }
        start({ startTime: startTime = window.performance.now() } = {}) {
            this.clear();
            (0, (0, parcelRequire("1a316")).logger).logCond(!!this.config.debug, this.key, startTime);
            this.state = "started";
            this.startTime = startTime;
            this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
            (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            this.watchUntil();
        }
        stop(stopArguments = {}) {
            const { stopTime: stopTime = window.performance.now() } = stopArguments;
            if (this.state !== "started" || this.startTime === null) {
                (0, (0, parcelRequire("1a316")).logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
                return false;
            }
            if (stopTime < this.startTime) {
                (0, (0, parcelRequire("1a316")).logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
                return false;
            }
            this.stopTime = stopTime;
            this.state = "finished";
            this.handleStop(stopArguments);
            (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return true;
        }
        handleStop(stopArguments) {
            const { customData: customData = null } = stopArguments;
            if (customData) this.custom = {
                ...this.custom,
                ...customData
            };
            this.config.include && this.config.include.forEach((metric)=>{
                const included = metric.getData();
                if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
            });
            this.onStopCallbacks.forEach(([success])=>{
                success(stopArguments);
            });
            this.onStopCallbacks = [];
            (0, (0, parcelRequire("1a316")).logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
        }
        mark(mark, timestamp = window.performance.now()) {
            this.marks[mark] = timestamp;
        }
        cancel() {
            if (this.state !== "started") return;
            this.state = "cancelled";
            this.cancelUntil();
            this.onStopCallbacks.forEach(([, cancel])=>{
                cancel();
            });
            this.onStopCallbacks = [];
            (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        }
        merge(mergeData) {
            this.state = mergeData.state;
            this.pageVisibleState = mergeData.pageVisibleState;
            this.startTime = mergeData.start;
            this.stopTime = mergeData.stop;
            this.marks = {
                ...this.marks,
                ...mergeData.marks
            };
            this.submetrics = [
                ...this.submetrics,
                ...mergeData.submetrics
            ];
            this.onStopCallbacks = [
                ...this.onStopCallbacks,
                ...mergeData.onStopCallbacks
            ];
        }
        onStop(success, cancel) {
            this.onStopCallbacks.push([
                success,
                cancel
            ]);
        }
        removeOnStopCallback(success) {
            const index = this.onStopCallbacks.findIndex(([successCallback])=>{
                return success === successCallback;
            });
            if (index > -1) this.onStopCallbacks.splice(index, 1);
        }
        getData() {
            return {
                key: this.key,
                state: this.state,
                start: this.startTime,
                stop: this.stopTime,
                marks: this.marks,
                custom: this.custom,
                submetrics: this.submetrics,
                config: this.config,
                route: this.route,
                pageVisibleState: this.pageVisibleState,
                type: this.config.type
            };
        }
        getDataToMerge() {
            return {
                ...this.getData(),
                onStopCallbacks: this.onStopCallbacks
            };
        }
        addSubMetric(data) {
            this.submetrics.push(data);
        }
        getConfiguredUntilMetric(metricOrConfig) {
            return metricOrConfig instanceof $d0da0e1fa3f8875a$export$2bce4ffdd840e878 ? (0, (0, parcelRequire("dNRIi")).UntilExperience).fromMetric(metricOrConfig) : (0, (0, parcelRequire("dNRIi")).UntilExperience).fromConfig(metricOrConfig);
        }
        getConfiguredUntilMetricArray(metricArray) {
            if (!metricArray.length) return [];
            return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
        }
        isUntilFinished() {
            return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
        }
        handleAllUntilFinished() {
            const sorted = [
                ...this.untilMetrics
            ].sort((m1, m2)=>{
                return m1.getDependencyStopTime() - m2.getDependencyStopTime();
            });
            const latestFullyInteractiveSegment = [
                ...this.untilMetrics
            ].reduce((currentLatestSegment, metric)=>{
                const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
                const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
                return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
            }, undefined);
            const accumulatedCustomData = {};
            sorted.forEach((metric)=>{
                Object.assign(accumulatedCustomData, metric.experience.getData().custom);
            });
            const latestSegment = sorted[sorted.length - 1];
            const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
            this.stop({
                stopTime: latestSegment.getDependencyStopTime(),
                customData: {
                    ...accumulatedCustomData,
                    segment: latestSegment.getKey(),
                    segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                    ...latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {}
                }
            });
        }
        watchUntil() {
            if (!this.untilMetrics.length) return;
            if (this.isUntilFinished()) {
                this.handleAllUntilFinished();
                return;
            }
            this.untilOnStopCallback = ()=>{
                if (this.isUntilFinished()) this.handleAllUntilFinished();
            };
            this.untilMetrics.forEach((metric)=>{
                if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
            });
        }
        cancelUntil() {
            this.untilMetrics.forEach((metric)=>{
                if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
            });
        }
        clear() {
            this.cancelUntil();
            this.state = "not-started";
            this.startTime = null;
            this.stopTime = null;
            this.marks = {};
            this.custom = null;
            this.submetrics = [];
            this.route = null;
            this.pageVisibleState = $d0da0e1fa3f8875a$var$getPageVisibleState();
        }
    }
});
parcelRegister("bopkp", function(module, exports) {
    $parcel$export(module.exports, "restrictedTimingKeys", ()=>$dba831f68643570c$export$1d17377365286b00);
    $parcel$export(module.exports, "clsWaitTimeMs", ()=>$dba831f68643570c$export$df21d285cfcda81e);
    const $dba831f68643570c$export$1d17377365286b00 = [
        'ssr'
    ];
    const $dba831f68643570c$export$df21d285cfcda81e = 7500;
});
parcelRegister("fCzt4", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$f980acfe8e701b39$export$13e680397ec8f3eb);
    class $f980acfe8e701b39$var$VisibilityChangeObserver {
        start() {
            document.addEventListener('visibilitychange', this.broadcast);
            window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $f980acfe8e701b39$export$13e680397ec8f3eb = new $f980acfe8e701b39$var$VisibilityChangeObserver();
});
parcelRegister("dNRIi", function(module, exports) {
    $parcel$export(module.exports, "UntilExperience", ()=>$309914b4389d4632$export$3fcc0936ee2cc852);
    class $309914b4389d4632$export$3fcc0936ee2cc852 {
        static{
            this.FMP = 'fmp';
        }
        static fromConfig(config) {
            return new $309914b4389d4632$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
        }
        static fromMetric(metric) {
            return new $309914b4389d4632$export$3fcc0936ee2cc852(metric);
        }
        constructor(experience, useFmpAsUntilStopTime){
            this.experience = experience;
            this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
        }
        getFmp() {
            const { marks: marks, stop: stop } = this.experience.getData();
            return marks[$309914b4389d4632$export$3fcc0936ee2cc852.FMP] ?? stop;
        }
        getDependencyStopTime() {
            if (this.useFmpAsUntilStopTime) return this.getFmp();
            return this.experience.getData().stop;
        }
        getFullyInteractiveStopTime() {
            return this.experience.getData().stop;
        }
        getIsSegmentLoadOverrided() {
            if (this.useFmpAsUntilStopTime) {
                const { marks: marks } = this.experience.getData();
                return marks[$309914b4389d4632$export$3fcc0936ee2cc852.FMP] ? true : false;
            }
            return false;
        }
        getKey() {
            return this.experience.getData().key;
        }
    }
});
parcelRegister("hjsyZ", function(module, exports) {
    $parcel$export(module.exports, "BasePageLoadMetric", ()=>$ae9e0b971909ad2b$export$fd1447b187f590fe);
    var $1a316;
    var $faqZ3;
    class $ae9e0b971909ad2b$export$fd1447b187f590fe extends (0, (0, parcelRequire("faqZ3")).BaseMetric) {
        static{
            this.FMP = 'fmp';
        }
        constructor(args){
            super(args);
            this.isInitial = true;
            this.explicitTimings = null;
            this.config = args;
        }
        start({} = {}) {
            return;
        }
        startPageLoad(params = {
            isInitial: false
        }) {
            this.isInitial = params.isInitial;
            if (params.isInitial) super.start({
                startTime: 0
            });
            else super.start(params);
            (0, (0, parcelRequire("1a316")).logger).logCond(!!this.config.debug, this.key, this.startTime);
        }
        stopPageLoad(pageLoadMetaMetricData, stopArguments = {
            stopTime: window.performance.now()
        }) {
            if (pageLoadMetaMetricData.state !== (0, (0, parcelRequire("faqZ3")).MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                (0, (0, parcelRequire("1a316")).logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
                return false;
            }
            if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                (0, (0, parcelRequire("1a316")).logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
                return false;
            }
            this.merge(pageLoadMetaMetricData);
            this.stopTime = stopArguments.stopTime;
            this.state = (0, (0, parcelRequire("faqZ3")).MetricState).FINISHED;
            this.handleStop(stopArguments);
            return true;
        }
        handleStop(stopArguments) {
            const { until: until } = this.config;
            const fmpWasMarked = $ae9e0b971909ad2b$export$fd1447b187f590fe.FMP in this.marks;
            if (!fmpWasMarked && until) {
                const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                    until
                ]);
                const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
                if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
            }
            super.handleStop(stopArguments);
        }
        mark(mark, timestamp = window.performance.now()) {
            if (mark === $ae9e0b971909ad2b$export$fd1447b187f590fe.FMP) return;
            super.mark(mark, timestamp);
        }
        merge(mergeData) {
            super.merge(mergeData);
            this.isInitial = mergeData.isInitial;
            this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
                ...mergeData.explicitTimings,
                ...this.explicitTimings
            } : null;
        }
        markFMP(timestamp) {
            super.mark($ae9e0b971909ad2b$export$fd1447b187f590fe.FMP, timestamp);
        }
        getPageLoadData() {
            return {
                isInitial: this.isInitial,
                explicitTimings: this.explicitTimings
            };
        }
        getData() {
            return {
                ...super.getData(),
                ...this.getPageLoadData()
            };
        }
        getDataToMerge() {
            return {
                ...super.getDataToMerge(),
                ...this.getPageLoadData()
            };
        }
        clear() {
            this.explicitTimings = null;
            super.clear();
        }
    }
});
parcelRegister("bC5TE", function(module, exports) {
    $parcel$export(module.exports, "webVitalsObserver", ()=>$f290d4298ee5dd10$export$253d38dccbb37615);
    class $f290d4298ee5dd10$var$WebVitalsObserver {
        start() {
            this.ttciDetermined = this.registerTTCI();
            this.webVitalsDetermined = this.registerWebVitals();
        }
        async registerWebVitals() {
            try {
                const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("ahp0n"));
                await Promise.all([
                    getTTFB,
                    getFID,
                    getFCP,
                    getLCP,
                    getCLS
                ].map((fx)=>new Promise((resolve)=>{
                        fx(({ name: name, value: value })=>{
                            const metricName = name.toLowerCase();
                            const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                            this.data[`metric:${metricName}`] = metricValue;
                            resolve();
                        });
                    })));
            } catch (e) {}
        }
        async registerTTCI() {
            try {
                const ttiPolyfill = await (parcelRequire("7XmIb"));
                await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                    this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                    return true;
                });
            } catch (e) {}
        }
        constructor(){
            this.data = {
                'metric:ttci': null,
                'metric:ttfb': null,
                'metric:fid': null,
                'metric:fcp': null,
                'metric:lcp': null,
                'metric:cls': null
            };
        }
    }
    const $f290d4298ee5dd10$export$253d38dccbb37615 = new $f290d4298ee5dd10$var$WebVitalsObserver();
});
parcelRegister("ahp0n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gceFf").then(()=>parcelRequire('gDSxx'));
});
parcelRegister("6fhBS", function(module, exports) {
    "use strict";
    function $48c1cdc5229a6006$var$load(id) {
        return import((parcelRequire("dy9lH")).resolve(id));
    }
    module.exports = $48c1cdc5229a6006$var$load;
});
parcelRegister("dy9lH", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v)=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
    $parcel$export(module.exports, "resolve", ()=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v)=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
    var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
    var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
    "use strict";
    var $9dd5b3e06d7b5702$var$mapping = new Map();
    function $9dd5b3e06d7b5702$var$register(baseUrl, manifest) {
        for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
            baseUrl: baseUrl,
            path: manifest[i + 1]
        });
    }
    function $9dd5b3e06d7b5702$var$resolve(id) {
        var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
        if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
        return new URL(resolved.path, resolved.baseUrl).toString();
    }
    $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
    $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;
});
parcelRegister("7XmIb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qy0v").then(()=>parcelRequire('8yzun'));
});
parcelRegister("dNz07", function(module, exports) {
    $parcel$export(module.exports, "Route", ()=>$9487519eee4f783e$export$e7b0ac011bb776c6);
    const $9487519eee4f783e$export$e7b0ac011bb776c6 = {
        route: '',
        setRoute (newRoute) {
            this.route = newRoute;
        },
        getRoute () {
            return this.route;
        }
    };
});
parcelRegister("9mLUv", function(module, exports) {
    $parcel$export(module.exports, "submitter", ()=>$6d437c00d0efd3b5$export$c21a25872e3f5a2b);
    var $bFU4G;
    var $2OjhD;
    var $1VnMk;
    var $iFc5T;
    const $6d437c00d0efd3b5$export$c21a25872e3f5a2b = {
        debug: false,
        config: {
            gasv3: undefined,
            configChunk: null,
            useVisibleState: false,
            histogram: {},
            enableReactUFOTracker: false
        },
        configure (config) {
            this.config.gasv3 = config.endpoints.eventPipelineClient;
            this.config.enableReactUFOTracker = config.enableReactUFOTracker;
            this.config.configChunk = (0, (0, parcelRequire("iFc5T")).makeShareableGlobalConfig)(config);
            if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, (0, parcelRequire("2OjhD")).PageVisibleFields).pageVisibleState;
        },
        setDebug (debug) {
            this.debug = debug;
        },
        async queue (data) {
            if (this.config.enableReactUFOTracker) (0, (0, parcelRequire("bFU4G")).addBrowserMetricEvent)(data);
            if (!this.config.configChunk) {
                this.debug && console.warn('Submitter is not configured');
                return null;
            }
            const chunk = await this.config.configChunk;
            const payload = await (0, (0, parcelRequire("1VnMk")).eventDataProcessor)(chunk[data.config.type], data);
            if (payload === null) return;
            if (this.config.gasv3 !== undefined) {
                const client = await this.config.gasv3;
                const attributes = {
                    task: payload['event:key'],
                    properties: payload
                };
                client && client.sendOperationalEvent({
                    actionSubject: 'performance',
                    attributes: attributes,
                    source: 'performance',
                    action: 'measured'
                });
            }
        }
    };
});
parcelRegister("1VnMk", function(module, exports) {
    $parcel$export(module.exports, "eventDataProcessor", ()=>$b5434d6816176e2f$export$896b6e121bbaec25);
    var $bopkp;
    var $1a316;
    var $bZsxw;
    var $9uajf;
    var $7jNuP;
    var $8Ic8h;
    var $j9Eek;
    var $jLd46;
    var $5bSM4;
    var $zvZP9;
    var $5dXPl;
    var $plhgc;
    var $hW0NK;
    var $z1c63;
    var $OV5vz;
    var $gqba1;
    var $h14Ri;
    var $18J7I;
    var $3nXa3;
    var $bqsDF;
    var $e12ut;
    var $c4WOp;
    var $cecKe;
    var $3CL6l;
    var $fOBx2;
    var $aklN4;
    var $6FD20;
    var $lgaHS;
    var $3Rrh2;
    var $7hfO8;
    var $glqAF;
    var $fNOPT;
    var $j3CL9;
    var $5qhne;
    var $7nZqE;
    var $9sxxV;
    var $2OjhD;
    const $b5434d6816176e2f$var$defaultSet = [
        (0, (0, parcelRequire("zvZP9")).eventKey),
        (0, (0, parcelRequire("OV5vz")).eventType),
        (0, (0, parcelRequire("plhgc")).eventProduct),
        (0, (0, parcelRequire("z1c63")).eventRoute),
        (0, (0, parcelRequire("jLd46")).eventId),
        (0, (0, parcelRequire("5dXPl")).eventLocalTime),
        (0, (0, parcelRequire("hW0NK")).eventRegion),
        (0, (0, parcelRequire("9uajf")).appFramework),
        (0, (0, parcelRequire("7jNuP")).appVersion),
        (0, (0, parcelRequire("8Ic8h")).bmVersion),
        (0, (0, parcelRequire("7hfO8")).telemetryBrowser),
        (0, (0, parcelRequire("glqAF")).telemetryCpu),
        (0, (0, parcelRequire("fNOPT")).telemetryMemory),
        (0, (0, parcelRequire("j3CL9")).telemetryNetwork),
        (0, (0, parcelRequire("j9Eek")).customData),
        (0, (0, parcelRequire("gqba1")).featureFlags),
        (0, (0, parcelRequire("h14Ri")).hostname),
        (0, (0, parcelRequire("6FD20")).productCustomData),
        (0, (0, parcelRequire("5qhne")).appTimings),
        (0, (0, parcelRequire("9sxxV")).resourceTimings)
    ];
    const $b5434d6816176e2f$var$pageLoadCommon = [
        ...$b5434d6816176e2f$var$defaultSet,
        (0, (0, parcelRequire("fOBx2")).pageVisibleState),
        (0, (0, parcelRequire("aklN4")).pageVisibleValue),
        (0, (0, parcelRequire("5bSM4")).eventInitial),
        (0, (0, parcelRequire("c4WOp")).pageLoadMetrics),
        (0, (0, parcelRequire("7nZqE")).bundleEvalTimings)
    ];
    const $b5434d6816176e2f$var$initialPageLoadSet = [
        ...$b5434d6816176e2f$var$pageLoadCommon,
        (0, (0, parcelRequire("3nXa3")).initialPageLoadMetrics),
        (0, (0, parcelRequire("e12ut")).navigationMetrics),
        (0, (0, parcelRequire("3Rrh2")).ssrSuccess),
        (0, (0, parcelRequire("lgaHS")).ssrFeatureFlags)
    ];
    const $b5434d6816176e2f$var$spaTransitionSet = [
        ...$b5434d6816176e2f$var$pageLoadCommon
    ];
    const $b5434d6816176e2f$var$pageSegmentLoadSet = [
        ...$b5434d6816176e2f$var$defaultSet,
        (0, (0, parcelRequire("cecKe")).pageSegmentLoadMetrics),
        (0, (0, parcelRequire("fOBx2")).pageVisibleState),
        (0, (0, parcelRequire("aklN4")).pageVisibleValue),
        (0, (0, parcelRequire("5bSM4")).eventInitial),
        (0, (0, parcelRequire("7nZqE")).bundleEvalTimings)
    ];
    const $b5434d6816176e2f$var$interactionSet = [
        ...$b5434d6816176e2f$var$defaultSet,
        (0, (0, parcelRequire("fOBx2")).pageVisibleState),
        (0, (0, parcelRequire("aklN4")).pageVisibleValue),
        (0, (0, parcelRequire("bqsDF")).interactionMetrics)
    ];
    const $b5434d6816176e2f$var$customMetricSet = [
        ...$b5434d6816176e2f$var$defaultSet,
        (0, (0, parcelRequire("fOBx2")).pageVisibleState),
        (0, (0, parcelRequire("aklN4")).pageVisibleValue),
        (0, (0, parcelRequire("18J7I")).customEventMetrics)
    ];
    const $b5434d6816176e2f$var$webVitalsMetricSet = [
        ...$b5434d6816176e2f$var$defaultSet,
        (0, (0, parcelRequire("3CL6l")).webVitalsMetrics)
    ];
    const $b5434d6816176e2f$var$waitForCLS = (delay = (0, (0, parcelRequire("bopkp")).clsWaitTimeMs) + 500)=>{
        return new Promise((resolve)=>setTimeout(resolve, delay));
    };
    const $b5434d6816176e2f$export$896b6e121bbaec25 = async (globalConfig, data)=>{
        if (data.start === null || data.stop === null) {
            (0, (0, parcelRequire("1a316")).logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
            return null;
        }
        let set = [];
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD && (0, (0, parcelRequire("bZsxw")).isPageLoadMetricData)(data) && data.isInitial) set = $b5434d6816176e2f$var$initialPageLoadSet;
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD && (0, (0, parcelRequire("bZsxw")).isPageLoadMetricData)(data) && !data.isInitial) set = $b5434d6816176e2f$var$spaTransitionSet;
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD && (0, (0, parcelRequire("bZsxw")).isPageSegmentLoadMetricData)(data)) set = $b5434d6816176e2f$var$pageSegmentLoadSet;
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT) set = $b5434d6816176e2f$var$interactionSet;
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM) set = $b5434d6816176e2f$var$customMetricSet;
        if (data.config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS) {
            set = $b5434d6816176e2f$var$webVitalsMetricSet;
            await $b5434d6816176e2f$var$waitForCLS();
        }
        const plugins = [];
        for (const plugin of set){
            const result = await plugin(data.config, data, globalConfig);
            if (result) plugins.push(result);
        }
        const pluginResults = await Promise.all(plugins);
        const generated = {};
        pluginResults.forEach((pluginResult)=>{
            if (pluginResult === null) return;
            Object.keys(pluginResult).forEach((key)=>{
                const keyResult = pluginResult[key];
                if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
            });
        });
        return generated;
    };
});
parcelRegister("bZsxw", function(module, exports) {
    $parcel$export(module.exports, "isPageLoadMetricData", ()=>$8a8179e6bf69b65d$export$b0e12e7abb0bff11);
    $parcel$export(module.exports, "isPageSegmentLoadMetricData", ()=>$8a8179e6bf69b65d$export$83d0099ee6dbb5b0);
    $parcel$export(module.exports, "isPageLoadConfig", ()=>$8a8179e6bf69b65d$export$8672fa27ba8bba88);
    $parcel$export(module.exports, "isPageSegmentLoadConfig", ()=>$8a8179e6bf69b65d$export$abe063537ef4987b);
    $parcel$export(module.exports, "isInteractionConfig", ()=>$8a8179e6bf69b65d$export$ae68674b6a9353be);
    $parcel$export(module.exports, "isCustomConfig", ()=>$8a8179e6bf69b65d$export$b493eb8b2ba87421);
    var $2OjhD;
    const $8a8179e6bf69b65d$export$b0e12e7abb0bff11 = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD;
    };
    const $8a8179e6bf69b65d$export$83d0099ee6dbb5b0 = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD;
    };
    const $8a8179e6bf69b65d$export$8672fa27ba8bba88 = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD;
    };
    const $8a8179e6bf69b65d$export$abe063537ef4987b = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD;
    };
    const $8a8179e6bf69b65d$export$ae68674b6a9353be = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT;
    };
    const $8a8179e6bf69b65d$export$b493eb8b2ba87421 = (data)=>{
        return data.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM;
    };
});
parcelRegister("9uajf", function(module, exports) {
    $parcel$export(module.exports, "appFramework", ()=>$7ebabdbf24c9fe98$export$e34e4529b979f74c);
    const $7ebabdbf24c9fe98$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
        if (!globalConfig.app.framework) return null;
        return {
            'app:framework:name': globalConfig.app.framework.name,
            'app:framework:version': globalConfig.app.framework.version
        };
    };
});
parcelRegister("7jNuP", function(module, exports) {
    $parcel$export(module.exports, "appVersion", ()=>$593f3c3cfdd9b91e$export$82ae485178b37419);
    const $593f3c3cfdd9b91e$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
        const pluginData = {
            'app:web:version': globalConfig.app.version.web
        };
        if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
        return pluginData;
    };
});
parcelRegister("8Ic8h", function(module, exports) {
    $parcel$export(module.exports, "bmVersion", ()=>$a996c517c928eee4$export$5cafa465fc876895);
    const $a996c517c928eee4$export$5cafa465fc876895 = ()=>{
        return {
            'bm:version': 3
        };
    };
});
parcelRegister("j9Eek", function(module, exports) {
    $parcel$export(module.exports, "customData", ()=>$26fd89fad3c47ede$export$f7e743c7db162193);
    const $26fd89fad3c47ede$export$f7e743c7db162193 = (_config, data)=>{
        const custom = {};
        let changed = false;
        if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
            changed = true;
            custom[`custom:${key}`] = value;
        });
        return changed ? custom : null;
    };
});
parcelRegister("jLd46", function(module, exports) {
    $parcel$export(module.exports, "eventId", ()=>$fd3e8851b2dbaa9c$export$aed28df7ac07d79a);
    const $fd3e8851b2dbaa9c$export$aed28df7ac07d79a = (config)=>{
        return {
            'event:id': config.key
        };
    };
});
parcelRegister("5bSM4", function(module, exports) {
    $parcel$export(module.exports, "eventInitial", ()=>$065f7a80483d1536$export$fa8e91d436b3ef8b);
    var $bZsxw;
    const $065f7a80483d1536$export$fa8e91d436b3ef8b = (_config, data)=>{
        if (!(0, (0, parcelRequire("bZsxw")).isPageLoadMetricData)(data) && !(0, (0, parcelRequire("bZsxw")).isPageSegmentLoadMetricData)(data)) return null;
        return {
            'event:initial': data.isInitial
        };
    };
});
parcelRegister("zvZP9", function(module, exports) {
    $parcel$export(module.exports, "eventKey", ()=>$40edfd4eb62e1855$export$10be2d3a558d3f88);
    var $3SSyX;
    const $40edfd4eb62e1855$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
        return {
            'event:key': `${globalConfig.product}.fe.${(0, (0, parcelRequire("3SSyX")).mapEventType)(config.type)}.${config.key}`
        };
    };
});
parcelRegister("3SSyX", function(module, exports) {
    $parcel$export(module.exports, "mapEventType", ()=>$6bf19b2de390745a$export$b334d07f11140768);
    var $2OjhD;
    const $6bf19b2de390745a$export$b334d07f11140768 = (type)=>{
        switch(type){
            case (0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM:
                return (0, (0, parcelRequire("2OjhD")).StorableBMEventsType).CUSTOM;
            case (0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT:
                return (0, (0, parcelRequire("2OjhD")).StorableBMEventsType).INLINE_RESULT;
            case (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD:
                return (0, (0, parcelRequire("2OjhD")).StorableBMEventsType).PAGE_LOAD;
            case (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD:
                return (0, (0, parcelRequire("2OjhD")).StorableBMEventsType).PAGE_SEGMENT_LOAD;
            case (0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS:
                return (0, (0, parcelRequire("2OjhD")).StorableBMEventsType).WEB_VITALS;
            default:
                return 'unknown';
        }
    };
});
parcelRegister("5dXPl", function(module, exports) {
    $parcel$export(module.exports, "eventLocalTime", ()=>$fdfd11229c536b50$export$5219854ae7ec45da);
    var $k7m40;
    const $fdfd11229c536b50$export$5219854ae7ec45da = ()=>({
            'event:localHour': parseInt((0, (0, parcelRequire("k7m40")).default)(new Date(), 'H'), 10),
            'event:localDayOfWeek': parseInt((0, (0, parcelRequire("k7m40")).default)(new Date(), 'i'), 10)
        });
});
parcelRegister("plhgc", function(module, exports) {
    $parcel$export(module.exports, "eventProduct", ()=>$236de010567e5ba1$export$a7df4e8088db8843);
    const $236de010567e5ba1$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
        return {
            'event:product': `${globalConfig.product}`
        };
    };
});
parcelRegister("hW0NK", function(module, exports) {
    $parcel$export(module.exports, "eventRegion", ()=>$9c98147f0ffde594$export$d0117b71adcdebc0);
    const $9c98147f0ffde594$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
        return {
            'event:region': `${globalConfig.region}`
        };
    };
});
parcelRegister("z1c63", function(module, exports) {
    $parcel$export(module.exports, "eventRoute", ()=>$1b1ee3885dec0024$export$44d3627af289ca16);
    const $1b1ee3885dec0024$export$44d3627af289ca16 = (_config, data)=>{
        if (!data.route) return null;
        return {
            'event:route': data.route
        };
    };
});
parcelRegister("OV5vz", function(module, exports) {
    $parcel$export(module.exports, "eventType", ()=>$9ecd37684592f4fe$export$4c045e605d532c98);
    var $3SSyX;
    const $9ecd37684592f4fe$export$4c045e605d532c98 = (config)=>{
        return {
            'event:type': (0, (0, parcelRequire("3SSyX")).mapEventType)(config.type)
        };
    };
});
parcelRegister("gqba1", function(module, exports) {
    $parcel$export(module.exports, "featureFlags", ()=>$e4a5e3d962b0f438$export$e62953d023125748);
    const $e4a5e3d962b0f438$export$e62953d023125748 = (config, _data, globalConfig)=>{
        const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
            acc[ffName] = globalConfig.ffClient.getValue(ffName);
            return acc;
        }, {}) || null;
        if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
        return {
            featureFlags: {
                ...localFeatureFlags,
                ...globalConfig.featureFlags
            }
        };
    };
});
parcelRegister("h14Ri", function(module, exports) {
    $parcel$export(module.exports, "hostname", ()=>$85a6c61f12e50306$export$640106f6dc7d2706);
    const $85a6c61f12e50306$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
        return {
            hostname: globalConfig.hostname
        };
    };
});
parcelRegister("18J7I", function(module, exports) {
    $parcel$export(module.exports, "customEventMetrics", ()=>$d852d0e129cf440f$export$cab039265c52a2e9);
    var $bZsxw;
    const $d852d0e129cf440f$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("bZsxw")).isCustomConfig)(config)) return null;
        const payload = {
            'metric:duration': Math.round(data.stop - data.start)
        };
        if (config.slo?.threshold !== undefined) {
            payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
            payload['metric:duration:slo:threshold'] = config.slo?.threshold;
        }
        if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
        else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
        return payload;
    };
});
parcelRegister("3nXa3", function(module, exports) {
    $parcel$export(module.exports, "initialPageLoadMetrics", ()=>$add2d86084023c49$export$cc95aa3f6ea8e5cb);
    const $add2d86084023c49$export$cc95aa3f6ea8e5cb = ()=>{
        const metrics = {};
        performance.getEntriesByType('paint').forEach((entry)=>{
            if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
            if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
        });
        return metrics;
    };
});
parcelRegister("bqsDF", function(module, exports) {
    $parcel$export(module.exports, "interactionMetrics", ()=>$5735b24edb83215a$export$86db56030b57ba34);
    var $bZsxw;
    var $2OjhD;
    const $5735b24edb83215a$export$86db56030b57ba34 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("bZsxw")).isInteractionConfig)(config)) return null;
        const result = {
            'metric:result': Math.round(data.stop - data.start)
        };
        if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, (0, parcelRequire("2OjhD")).BMInteractionMetrics).result];
        }
        if (config.slo && (0, (0, parcelRequire("2OjhD")).isInteractionMetricsSlo)(config.slo) && config.slo.result) {
            result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
            result['metric:result:slo:threshold'] = config.slo.result.threshold;
        }
        if (data.marks['feedback']) {
            result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
            if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, (0, parcelRequire("2OjhD")).BMInteractionMetrics).response];
            else if (globalConfig.histogram) {
                const histogram = globalConfig.histogram;
                if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, (0, parcelRequire("2OjhD")).BMInteractionMetrics).response];
            }
            if (config.slo && (0, (0, parcelRequire("2OjhD")).isInteractionMetricsSlo)(config.slo) && config.slo.response) {
                result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
                result['metric:response:slo:threshold'] = config.slo.response.threshold;
            }
        }
        return result;
    };
});
parcelRegister("e12ut", function(module, exports) {
    $parcel$export(module.exports, "navigationMetrics", ()=>$b1d94387f599e941$export$b88d990436be0f8a);
    const $b1d94387f599e941$export$b88d990436be0f8a = ()=>{
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        const metrics = {
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart)
        };
        return {
            'metrics:navigation': metrics
        };
    };
});
parcelRegister("c4WOp", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetrics", ()=>$5709718468179f7d$export$2878bf482e539059);
    var $bZsxw;
    var $2OjhD;
    const $5709718468179f7d$var$getThreshold = (isInitial, metric)=>{
        return (0, (0, parcelRequire("2OjhD")).isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
    };
    const $5709718468179f7d$var$getHistogram = (isInitial, metric, histogram)=>{
        return isInitial ? histogram.initial[metric] : histogram.transition[metric];
    };
    const $5709718468179f7d$export$2878bf482e539059 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("bZsxw")).isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
        const fmp = data.marks[(0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).fmp] || data.stop;
        const result = {
            'metric:fmp': Math.round(fmp - data.start),
            'metric:tti': Math.round(data.stop - data.start)
        };
        if (config.histogram) {
            result['metric:fmp:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).fmp, config.histogram);
            result['metric:tti:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).tti, config.histogram);
        } else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            result['metric:fmp:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).fmp, histogram);
            result['metric:tti:histogramBuckets'] = $5709718468179f7d$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).tti, histogram);
        }
        if (config.slo && config.slo.fmp) {
            const threshold = $5709718468179f7d$var$getThreshold(data.isInitial, config.slo.fmp);
            result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
            result['metric:fmp:slo:threshold'] = threshold;
        }
        if (config.slo && config.slo.tti) {
            const threshold = $5709718468179f7d$var$getThreshold(data.isInitial, config.slo.tti);
            result['metric:tti:slo'] = result['metric:tti'] <= threshold;
            result['metric:tti:slo:threshold'] = threshold;
        }
        return result;
    };
});
parcelRegister("cecKe", function(module, exports) {
    $parcel$export(module.exports, "pageSegmentLoadMetrics", ()=>$e878bbf4c7475a57$export$ba86cb47f2f22db5);
    var $7cRo8;
    var $bZsxw;
    var $2OjhD;
    const $e878bbf4c7475a57$var$getThreshold = (isInitial, metric)=>{
        return (0, (0, parcelRequire("2OjhD")).isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
    };
    const $e878bbf4c7475a57$var$getHistogram = (isInitial, metric, histogram)=>{
        return isInitial ? histogram.initial[metric] : histogram.transition[metric];
    };
    const $e878bbf4c7475a57$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("bZsxw")).isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
        const fmp = data.marks[(0, (0, parcelRequire("2OjhD")).BMPageSegmentLoadMetrics).fmp] || data.stop;
        const result = {
            'metric:fmp': Math.round(fmp - data.start),
            'metric:tti': Math.round(data.stop - data.start)
        };
        if (config.histogram) {
            result['metric:fmp:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageSegmentLoadMetrics).fmp, config.histogram);
            result['metric:tti:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageSegmentLoadMetrics).tti, config.histogram);
        } else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            result['metric:fmp:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageSegmentLoadMetrics).fmp, histogram);
            result['metric:tti:histogramBuckets'] = $e878bbf4c7475a57$var$getHistogram(data.isInitial, (0, (0, parcelRequire("2OjhD")).BMPageSegmentLoadMetrics).tti, histogram);
        }
        if (config.slo?.fmp) {
            const threshold = $e878bbf4c7475a57$var$getThreshold(data.isInitial, config.slo.fmp);
            result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
            result['metric:fmp:slo:threshold'] = threshold;
        }
        if (config.slo?.tti) {
            const threshold = $e878bbf4c7475a57$var$getThreshold(data.isInitial, config.slo.tti);
            result['metric:tti:slo'] = result['metric:tti'] <= threshold;
            result['metric:tti:slo:threshold'] = threshold;
        }
        if (config.includePageLoadTimings === (0, (0, parcelRequire("2OjhD")).PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, (0, parcelRequire("2OjhD")).PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
            const pageLoadData = (0, (0, parcelRequire("7cRo8")).pageLoadMetaMetric).getData();
            const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, (0, parcelRequire("2OjhD")).BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
            const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
            result['pageLoad'] = {
                fmp: fmp,
                tti: tti
            };
        }
        return result;
    };
});
parcelRegister("3CL6l", function(module, exports) {
    $parcel$export(module.exports, "webVitalsMetrics", ()=>$652c6f042ecfbc5f$export$3731db279f590f30);
    var $faqZ3;
    var $fCzt4;
    var $bC5TE;
    var $aklN4;
    const $652c6f042ecfbc5f$export$3731db279f590f30 = async (config, data, globalConfig)=>{
        let pageVisibleState = data.pageVisibleState;
        const setPageVisibleStateToMixed = ()=>{
            pageVisibleState = (0, (0, parcelRequire("faqZ3")).PageVisibleState).MIXED;
        };
        (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
        const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
        const webVitalMetrics = await $652c6f042ecfbc5f$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
        (0, (0, parcelRequire("fCzt4")).visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
        return {
            ...webVitalMetrics,
            'pageVisible:state': pageVisibleState,
            ...(0, (0, parcelRequire("aklN4")).pageVisibleValue)(config, data, globalConfig)
        };
    };
    const $652c6f042ecfbc5f$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
        await (ttciEnabled ? (0, (0, parcelRequire("bC5TE")).webVitalsObserver).ttciDetermined : Promise.resolve());
        const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
        await Promise.race([
            timeoutWindow,
            (0, (0, parcelRequire("bC5TE")).webVitalsObserver).webVitalsDetermined
        ]);
        return (0, (0, parcelRequire("bC5TE")).webVitalsObserver).data;
    };
});
parcelRegister("aklN4", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleValue", ()=>$166fc81eec453bf7$export$177b923114656380);
    var $faqZ3;
    var $2OjhD;
    const $166fc81eec453bf7$export$177b923114656380 = (_config, data, globalConfig)=>{
        const value = globalConfig.pageVisibleValueOrigin === (0, (0, parcelRequire("2OjhD")).PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, (0, parcelRequire("faqZ3")).PageVisibleState).VISIBLE;
        return {
            'pageVisible:value': value
        };
    };
});
parcelRegister("fOBx2", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleState", ()=>$7c7f0b0122360f2b$export$723b4c298aca63af);
    const $7c7f0b0122360f2b$export$723b4c298aca63af = (_config, data)=>{
        return {
            'pageVisible:state': data.pageVisibleState
        };
    };
});
parcelRegister("6FD20", function(module, exports) {
    $parcel$export(module.exports, "productCustomData", ()=>$d71002744d91ac87$export$fa2af6e412815a74);
    const $d71002744d91ac87$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
        if (!globalConfig.custom && !globalConfig.plugins) return null;
        const result = {};
        if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
            result[`${globalConfig.product}:${key}`] = value;
        });
        if (globalConfig.plugins) {
            const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                    start: data.start,
                    stop: data.stop,
                    key: data.key
                })));
            pluginOutputs.forEach((pluginOutput)=>{
                if (pluginOutput === null) return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${globalConfig.product}:${key}`] = value;
                });
            });
        }
        return result;
    };
});
parcelRegister("lgaHS", function(module, exports) {
    $parcel$export(module.exports, "ssrFeatureFlags", ()=>$4df746887e3c55a7$export$fdbea518c19dfa8);
    var $2OjhD;
    const $4df746887e3c55a7$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
        try {
            const featureFlags = await getFeatureFlags();
            if (featureFlags) return {
                'ssr:featureFlags': featureFlags
            };
        } catch (e) {}
        return null;
    };
    const $4df746887e3c55a7$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
        if (!globalConfig.ssr?.getFeatureFlags) return null;
        const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, (0, parcelRequire("2OjhD")).IncludeSSRFeatureFlagsConfig).WHEN_FMP;
        if (includeFeatureFlags === (0, (0, parcelRequire("2OjhD")).IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, (0, parcelRequire("2OjhD")).IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $4df746887e3c55a7$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
        return null;
    };
});
parcelRegister("3Rrh2", function(module, exports) {
    $parcel$export(module.exports, "ssrSuccess", ()=>$ccf848c1503bcb30$export$a3dc8251cf55b2e0);
    const $ccf848c1503bcb30$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
        if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
            'ssr:success': true
        };
        return null;
    };
});
parcelRegister("7hfO8", function(module, exports) {
    $parcel$export(module.exports, "telemetryBrowser", ()=>$5b4b49b00929873c$export$386b10ac64a50b1);
    var $4XKM3 = parcelRequire("4XKM3");
    const $5b4b49b00929873c$export$386b10ac64a50b1 = ()=>{
        if (!(0, ($parcel$interopDefault($4XKM3))).getParser) return null;
        const browser = (0, ($parcel$interopDefault($4XKM3))).getParser(window.navigator.userAgent);
        return {
            'telemetry:browser:name': browser.getBrowserName(),
            'telemetry:browser:version': browser.getBrowserVersion()
        };
    };
});
parcelRegister("glqAF", function(module, exports) {
    $parcel$export(module.exports, "telemetryCpu", ()=>$9eabb6050555fa45$export$9f84cb359ed29139);
    const $9eabb6050555fa45$export$9f84cb359ed29139 = ()=>{
        if (!navigator.hardwareConcurrency) return null;
        return {
            'telemetry:cpus': navigator.hardwareConcurrency
        };
    };
});
parcelRegister("fNOPT", function(module, exports) {
    $parcel$export(module.exports, "telemetryMemory", ()=>$a8d8496e21704efb$export$496c14d72b257e07);
    const $a8d8496e21704efb$export$496c14d72b257e07 = ()=>{
        if (!navigator.deviceMemory) return null;
        return {
            'telemetry:memory': navigator.deviceMemory
        };
    };
});
parcelRegister("j3CL9", function(module, exports) {
    $parcel$export(module.exports, "telemetryNetwork", ()=>$97af46a2100383e5$export$88bf7b55f7fc4e8e);
    const $97af46a2100383e5$export$88bf7b55f7fc4e8e = ()=>{
        if (!navigator.connection) return null;
        return {
            'telemetry:network:effectiveType': navigator.connection.effectiveType,
            'telemetry:network:rtt': navigator.connection.rtt,
            'telemetry:network:downlink': navigator.connection.downlink
        };
    };
});
parcelRegister("5qhne", function(module, exports) {
    $parcel$export(module.exports, "appTimings", ()=>$d403b3630c7eca6f$export$e952f50a4f2d02da);
    var $2OjhD;
    var $a83l4;
    var $gKqV5;
    const $d403b3630c7eca6f$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
        const explicitTimings = config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD && data.explicitTimings || null;
        const timings = (0, (0, parcelRequire("a83l4")).customTimings)(config, data);
        const ssr = config.type === (0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD && data.isInitial ? (0, (0, parcelRequire("gKqV5")).ssrTimings)(config, data, globalConfig) : null;
        const timingsApp = (explicitTimings || timings || ssr) && {
            ...explicitTimings,
            ...timings,
            ...ssr
        };
        if (!timingsApp) return null;
        return {
            'timings:app': timingsApp
        };
    };
});
parcelRegister("a83l4", function(module, exports) {
    $parcel$export(module.exports, "customTimings", ()=>$d861c161712d83ed$export$6126f85083a72c6e);
    const $d861c161712d83ed$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
        const configTimings = config.timings || [];
        const timings = configTimings.reduce((entries, timing)=>{
            if (timing.startMark && !data.marks[timing.startMark]) return entries;
            if (timing.endMark && !data.marks[timing.endMark]) return entries;
            if (data.start === null || data.stop === null) return null;
            const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
            const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
            entries[`${prefix}${timing.key}`] = {
                startTime: startTime,
                duration: duration
            };
            return entries;
        }, {});
        return timings;
    };
    const $d861c161712d83ed$export$6126f85083a72c6e = (config, data)=>{
        if (!config.timings && data.submetrics.length === 0) return null;
        const timings = $d861c161712d83ed$var$retrieveTimings(config, data);
        data.submetrics.forEach((submetric)=>{
            if (submetric.start !== null && submetric.stop !== null) {
                const submetricPrefix = `include:${submetric.config.key}`;
                timings[submetricPrefix] = {
                    startTime: Math.round(submetric.start - data.start),
                    duration: Math.round(submetric.stop - submetric.start)
                };
                Object.assign(timings, $d861c161712d83ed$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $636842cf8e8f850b$export$b98e411ae80c806f)));
            }
        });
        if (Object.keys(timings).length === 0) return null;
        return timings;
    };
});
const $636842cf8e8f850b$export$b98e411ae80c806f = '/';
parcelRegister("gKqV5", function(module, exports) {
    $parcel$export(module.exports, "ssrTimings", ()=>$4eac1f1b5e5e13f8$export$130f411261a599c5);
    const $4eac1f1b5e5e13f8$var$filterEntry = (entry)=>{
        return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    };
    const $4eac1f1b5e5e13f8$var$mapEntry = (entry)=>{
        return {
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        };
    };
    const $4eac1f1b5e5e13f8$var$SSR_PREFIX = 'ssr';
    const $4eac1f1b5e5e13f8$var$mapKey = (key)=>{
        if (key === 'total') return $4eac1f1b5e5e13f8$var$SSR_PREFIX;
        return `${$4eac1f1b5e5e13f8$var$SSR_PREFIX}${0, $636842cf8e8f850b$export$b98e411ae80c806f}${key}`;
    };
    const $4eac1f1b5e5e13f8$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
        if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
        const timings = globalConfig.ssr.getTimings();
        if (!timings) return null;
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($4eac1f1b5e5e13f8$var$filterEntry(entry[1])) acc[$4eac1f1b5e5e13f8$var$mapKey(entry[0])] = $4eac1f1b5e5e13f8$var$mapEntry(entry[1]);
            return acc;
        }, {});
        if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
        return ssrTimings;
    };
});
parcelRegister("7nZqE", function(module, exports) {
    $parcel$export(module.exports, "bundleEvalTimings", ()=>$d63b06bb3b343068$export$1a2bb347935fc536);
    const $d63b06bb3b343068$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
        const started = {};
        const timings = {};
        const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
        performance.getEntriesByType('mark').forEach((mark)=>{
            if (!globalConfig.bundleEvalTimings) return;
            const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: Math.round(started[name].startTime - data.start),
                    duration: Math.round(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
            const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
            if (result) Object.entries(result).forEach(([key, value])=>{
                timings[key] = value;
            });
        }
        if (Object.keys(timings).length === 0) return null;
        return {
            'timings:bundleEval': timings
        };
    };
    const $d63b06bb3b343068$export$1a2bb347935fc536 = (...args)=>{
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($d63b06bb3b343068$var$bundleEvalTimingsInternal(...args));
            });
        });
    };
});
parcelRegister("9sxxV", function(module, exports) {
    $parcel$export(module.exports, "resourceTimings", ()=>$103f343fd312afd6$export$81a7d52441a06b50);
    const $103f343fd312afd6$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $103f343fd312afd6$var$resourceTypes = [
        'fetch',
        'xmlhttprequest'
    ];
    const $103f343fd312afd6$var$CACHE_NETWORK = 'network';
    const $103f343fd312afd6$var$CACHE_MEMORY = 'memory';
    const $103f343fd312afd6$var$CACHE_DISK = 'disk';
    const $103f343fd312afd6$var$calculateTransferType = (type, duration, size)=>{
        if (!$103f343fd312afd6$var$cacheableTypes.includes(type)) return $103f343fd312afd6$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $103f343fd312afd6$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $103f343fd312afd6$var$CACHE_DISK;
        if (size === undefined) return null;
        return $103f343fd312afd6$var$CACHE_NETWORK;
    };
    const $103f343fd312afd6$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
        return !$103f343fd312afd6$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
    };
    const $103f343fd312afd6$var$getReportedInitiatorTypes = (xhrEnabled)=>{
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    };
    const $103f343fd312afd6$var$withoutHeaders = ()=>false;
    const $103f343fd312afd6$var$evaluateAccessToResourceTimings = (entry)=>{
        if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
        return true;
    };
    const $103f343fd312afd6$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $103f343fd312afd6$var$withoutHeaders)=>{
        if (!enabled) return null;
        const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
        const autoResolution = $103f343fd312afd6$var$evaluateAccessToResourceTimings(entry);
        return {
            m_h: manualResolution,
            a_h: autoResolution
        };
    };
    const $103f343fd312afd6$var$getSizeObject = (size)=>size !== undefined ? {
            size: size
        } : null;
    const $103f343fd312afd6$var$getNetworkData = (item, eventStart, hasTimingHeaders = $103f343fd312afd6$var$withoutHeaders)=>{
        const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
        const ttfb = Math.round(responseStart - eventStart);
        if (!$103f343fd312afd6$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
        if ($103f343fd312afd6$var$cacheableTypes.includes(type)) {
            const transferType = $103f343fd312afd6$var$calculateTransferType(type, duration, size);
            if (!transferType) return {
                ttfb: ttfb,
                ...$103f343fd312afd6$var$getSizeObject(size)
            };
            if (transferType !== $103f343fd312afd6$var$CACHE_NETWORK) return {
                transferType: transferType
            };
            return {
                ttfb: ttfb,
                transferType: transferType,
                ...$103f343fd312afd6$var$getSizeObject(size)
            };
        }
        return {
            ttfb: ttfb,
            ...$103f343fd312afd6$var$getSizeObject(size)
        };
    };
    const $103f343fd312afd6$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
        if (data.start === null) return null;
        const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
        if (!resources.length) return null;
        const resourceTiming = {};
        const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
        const reportedInitiatorTypes = $103f343fd312afd6$var$getReportedInitiatorTypes(!!xhrFilter);
        resources.forEach((item)=>{
            if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
            const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
            if (!name) return;
            if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
            const url = $103f343fd312afd6$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
            if (resourceTiming[url]) return;
            resourceTiming[url] = {
                startTime: Math.round(startTime - data.start),
                duration: Math.round(duration),
                workerStart: Math.max(Math.round(workerStart - data.start), 0),
                fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
                type: type,
                ...$103f343fd312afd6$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
                ...$103f343fd312afd6$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
            };
        });
        return {
            'timings:resource': resourceTiming
        };
    };
});
parcelRegister("iFc5T", function(module, exports) {
    $parcel$export(module.exports, "makeShareableGlobalConfig", ()=>$e210a9ede499ed9e$export$5b4fb14409a2a825);
    var $2OjhD;
    const $e210a9ede499ed9e$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
        const featureFlagsForType = [];
        if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
        if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
        return featureFlagsForType;
    };
    const $e210a9ede499ed9e$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
        const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
        const eventConfigCustom = eventConfig && eventConfig.custom;
        const custom = (allEventsConfigCustom || eventConfigCustom) && {
            ...allEventsConfigCustom,
            ...eventConfigCustom
        } || undefined;
        const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
        const eventConfigPlugins = eventConfig && eventConfig.plugins;
        const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
            ...allEventsConfigPlugins || [],
            ...eventConfigPlugins || []
        ] || undefined;
        const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, (0, parcelRequire("2OjhD")).PageVisibleValueOrigin).documentHidden;
        return Object.freeze({
            ...global,
            featureFlags: Object.freeze($e210a9ede499ed9e$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
                acc[value] = ffClient.getValue(value);
                return acc;
            }, {})),
            custom: custom,
            plugins: plugins,
            histogram: eventConfig?.histogram,
            pageVisibleValueOrigin: pageVisibleValueOrigin,
            enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
        });
    };
    const $e210a9ede499ed9e$export$5b4fb14409a2a825 = async (globalConfig)=>{
        const ffClient = await globalConfig.plugins.featureFlags.client;
        const global = {
            app: globalConfig.info.app,
            product: globalConfig.info.product,
            region: globalConfig.info.region,
            resourceTimings: globalConfig.plugins.resourceTimings,
            bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
            ffClient: ffClient,
            hostname: globalConfig.info.hostname || window.location.hostname,
            ssr: globalConfig.ssr,
            enableReactUFOTracker: globalConfig.enableReactUFOTracker,
            webVitals: {
                enabled: globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS]?.enabled,
                timeout: globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS]?.timeout,
                ttciEnabled: globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS]?.ttciEnabled
            }
        };
        return {
            [(0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_LOAD]),
            [(0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).PAGE_SEGMENT_LOAD]),
            [(0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).INLINE_RESULT]),
            [(0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).CUSTOM]),
            [(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS]: $e210a9ede499ed9e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("2OjhD")).BMEventsType).WEB_VITALS])
        };
    };
});
parcelRegister("eoXiD", function(module, exports) {
    $parcel$export(module.exports, "ufologger", ()=>$571cc62004c36239$export$4ab84f6f04f6566d);
    $parcel$export(module.exports, "ufolog", ()=>$571cc62004c36239$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$571cc62004c36239$export$d53d07b6034c4560);
    class $571cc62004c36239$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($571cc62004c36239$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($571cc62004c36239$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $571cc62004c36239$export$4ab84f6f04f6566d = new $571cc62004c36239$var$UFOLogger();
    const $571cc62004c36239$export$b4958caff08a0960 = (...args)=>{
        $571cc62004c36239$export$4ab84f6f04f6566d.log(...args);
    };
    const $571cc62004c36239$export$d53d07b6034c4560 = (...args)=>{
        $571cc62004c36239$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("8Nn2p", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$9591752280ca5b01$export$15e172712955e18f);
    const $9591752280ca5b01$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("iJHxx", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$db239cdfaae621d7$export$6123a44dc2384540);
    $parcel$export(module.exports, "setGlobalEventStream", ()=>$db239cdfaae621d7$export$c1522520b417b066);
    $parcel$export(module.exports, "subscribeEvent", ()=>$db239cdfaae621d7$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$db239cdfaae621d7$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$db239cdfaae621d7$export$7c957416596ca127);
    var $eoXiD;
    var $fSTSz;
    const $db239cdfaae621d7$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $db239cdfaae621d7$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $db239cdfaae621d7$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $db239cdfaae621d7$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("eoXiD")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $db239cdfaae621d7$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $db239cdfaae621d7$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $db239cdfaae621d7$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("fSTSz", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$aa871f66b1a2d453$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$aa871f66b1a2d453$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$aa871f66b1a2d453$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$aa871f66b1a2d453$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$aa871f66b1a2d453$export$837e0f79a8056912);
    var $aa871f66b1a2d453$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($aa871f66b1a2d453$export$96253c35c37cf96b || ($aa871f66b1a2d453$export$96253c35c37cf96b = {}));
    var $aa871f66b1a2d453$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($aa871f66b1a2d453$export$a12c67b37a306b13 || ($aa871f66b1a2d453$export$a12c67b37a306b13 = {}));
    var $aa871f66b1a2d453$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($aa871f66b1a2d453$export$66b33c055cbb625e || ($aa871f66b1a2d453$export$66b33c055cbb625e = {}));
    var $aa871f66b1a2d453$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($aa871f66b1a2d453$export$3ce489cbe02dc21b || ($aa871f66b1a2d453$export$3ce489cbe02dc21b = {}));
    var $aa871f66b1a2d453$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($aa871f66b1a2d453$export$341b330828bd3906 || ($aa871f66b1a2d453$export$341b330828bd3906 = {}));
    var $aa871f66b1a2d453$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($aa871f66b1a2d453$export$b9b20160f581e4f8 || ($aa871f66b1a2d453$export$b9b20160f581e4f8 = {}));
    const $aa871f66b1a2d453$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $aa871f66b1a2d453$export$9f2bf58999404c75 = 'fmp';
    const $aa871f66b1a2d453$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("3aRrh", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$0f64fa92f0a44c04$export$13e680397ec8f3eb);
    var $8Nn2p;
    class $0f64fa92f0a44c04$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("8Nn2p")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $0f64fa92f0a44c04$export$13e680397ec8f3eb = new $0f64fa92f0a44c04$var$VisibilityChangeObserver();
});
parcelRegister("atdLB", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$648975f2f02f5db7$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$648975f2f02f5db7$export$cc26007c03242fff);
    var $648975f2f02f5db7$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($648975f2f02f5db7$export$994164cf3ae1cc9a || ($648975f2f02f5db7$export$994164cf3ae1cc9a = {}));
    var $648975f2f02f5db7$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($648975f2f02f5db7$export$cc26007c03242fff || ($648975f2f02f5db7$export$cc26007c03242fff = {}));
});
parcelRegister("49z18", function(module, exports) {
    $parcel$export(module.exports, "payloadPublisher", ()=>$02c157c65157adaa$export$edb879ae55bb9be3);
    var $atdLB;
    var $3aRrh;
    var $iJHxx;
    var $eoXiD;
    var $fSTSz;
    var $9na5h;
    var $cnlxp;
    var $ep4ut;
    var $jdaZR;
    var $dFbEk;
    var $1rlqb;
    var $8vdI1;
    var $7xyGJ;
    var $6IMTA;
    var $dc6Kb;
    var $aHGCE;
    var $l4Z6i;
    var $4btcP;
    var $foo60;
    var $e1BKK;
    var $dK6It;
    var $8Vhtb;
    const $02c157c65157adaa$var$UNKNOWN_VALUE = 'unknown';
    const $02c157c65157adaa$var$DEFAULT_PAYLOAD_DATA = {
        schemaVersion: $02c157c65157adaa$var$UNKNOWN_VALUE,
        id: $02c157c65157adaa$var$UNKNOWN_VALUE,
        uuid: $02c157c65157adaa$var$UNKNOWN_VALUE,
        state: {
            id: $02c157c65157adaa$var$UNKNOWN_VALUE
        },
        result: {
            startTime: 0,
            duration: 0,
            success: false
        },
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        category: $02c157c65157adaa$var$UNKNOWN_VALUE,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        metadata: {},
        explicitTimings: {},
        metrics: {
            startTime: 0,
            endTime: 0,
            marks: []
        },
        platform: null,
        children: [],
        pageVisibleState: (0, (0, parcelRequire("fSTSz")).PageVisibleState).MIXED,
        isSSROutputAsFMP: false,
        timings: [],
        featureFlags: []
    };
    class $02c157c65157adaa$var$Publisher {
        publish(data) {
            const payloadStart = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)()?.now() || 0;
            const experienceKey = this.getExperienceKey(data);
            if (!this.allowlist(experienceKey, data)) {
                (0, (0, parcelRequire("eoXiD")).ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
                return;
            }
            const supportedData = {
                ...$02c157c65157adaa$var$DEFAULT_PAYLOAD_DATA,
                ...data
            };
            const payload = {
                actionSubject: 'experience',
                action: 'measured',
                source: 'measured',
                tags: [
                    'observability'
                ],
                attributes: {
                    properties: {
                        'event:source': {
                            name: 'ufo/web',
                            version: supportedData.schemaVersion
                        },
                        'event:schema': (0, $46f5b02486779691$export$93809551debf385f) || $02c157c65157adaa$var$UNKNOWN_VALUE,
                        'event:product': this.product,
                        'event:region': this.region,
                        'event:hostname': this.hostname,
                        'event:route': this.route.getRoute(),
                        ...(0, (0, parcelRequire("7xyGJ")).eventBrowserPlugin)(),
                        ...(0, (0, parcelRequire("6IMTA")).eventCpusPlugin)(),
                        ...(0, (0, parcelRequire("aHGCE")).eventMemoryPlugin)(),
                        ...(0, (0, parcelRequire("l4Z6i")).eventNetworkPlugin)(),
                        ...(0, (0, parcelRequire("1rlqb")).appFramework)(this.app),
                        ...(0, (0, parcelRequire("8vdI1")).appVersion)(this.app),
                        'experience:name': supportedData.id,
                        'experience:key': experienceKey,
                        'experience:status': supportedData.state.id,
                        'experience:duration': supportedData.result.duration,
                        ...supportedData.result.startTime !== null ? {
                            'experience:startTime': supportedData.result.startTime
                        } : null,
                        ...supportedData.uuid ? {
                            'experience:spanId': supportedData.uuid
                        } : null,
                        ...this.tenantType !== (0, (0, parcelRequire("9na5h")).TenantType).RealUser ? {
                            'event:tenantType': this.tenantType
                        } : null,
                        ...this.mapMetadataToPayload(supportedData.metadata),
                        ...this.extractPageLoadData(supportedData),
                        ...(0, (0, parcelRequire("jdaZR")).pageVisibleState)(supportedData),
                        ...(0, (0, parcelRequire("dK6It")).isInitialPageLoad)(supportedData) && (0, (0, parcelRequire("foo60")).ssrSuccess)(this.ssr),
                        ...(0, (0, parcelRequire("dK6It")).isInitialPageLoad)(supportedData) && (0, (0, parcelRequire("4btcP")).ssrFeatureFlags)(this.ssr),
                        ...this.featureFlagClient && (0, (0, parcelRequire("dc6Kb")).featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                    },
                    performance: this.getPerformanceMetrics(supportedData),
                    task: supportedData.id
                }
            };
            const payloadEnd = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)()?.now() || 0;
            payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
            if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
            else this.buffer.push(payload);
            (0, (0, parcelRequire("eoXiD")).ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
        }
        setGlobalEventStream() {
            if (!((0, (0, parcelRequire("iJHxx")).getGlobalEventStream)() instanceof (0, (0, parcelRequire("cnlxp")).UFOGlobalEventStream))) {
                const eventStream = new (0, (0, parcelRequire("cnlxp")).UFOGlobalEventStream)();
                eventStream.push({
                    type: (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).SUBSCRIBE,
                    payload: {
                        experienceId: '__SUBSCRIBE_ALL__',
                        callback: this.publish.bind(this)
                    }
                });
                (0, (0, parcelRequire("iJHxx")).setGlobalEventStream)(eventStream);
            }
        }
        setRoute(newRoute) {
            this.route.setRoute(newRoute);
        }
        setup(config) {
            (0, (0, parcelRequire("3aRrh")).visibilityChangeObserver).start();
            (0, (0, parcelRequire("dFbEk")).resourceTimingBuffer).start();
            if (!this.product) this.product = config.product || '';
            if (config.allowlist) this.allowlist = config.allowlist;
            if (config.tenantType) this.tenantType = config.tenantType;
            if (config.hostname) this.hostname = config.hostname;
            if (config.region) this.region = config.region;
            if (config.app) this.app = config.app;
            if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
            if (config.featureFlags) this.featureFlags = config.featureFlags;
            if (config.ssr) this.ssr = config.ssr;
            if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
            if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
            if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
            if (config.plugins) this.plugins = config.plugins;
            this.setGlobalEventStream();
            if (!this.gasv3) {
                this.gasv3 = config.gasv3;
                this.buffer.forEach(this.gasv3.sendOperationalEvent);
            }
        }
        mapMetadataToPayload(metadata) {
            const payload = {};
            Object.entries(metadata).forEach(([key, value])=>{
                if (value !== undefined) payload[`custom:${key}`] = value;
            });
            return payload;
        }
        extractPageLoadData(data) {
            if ('initial' in data) return {
                'experience:pageLoadType': data.initial ? 'initial' : 'transition'
            };
            return {};
        }
        getPrefix(data) {
            if (data.platform !== null) return 'platform';
            return this.product;
        }
        getExperienceKey(data) {
            const keyParts = [
                this.getPrefix(data),
                'fe',
                data.type
            ];
            if (data.platform) keyParts.push(data.platform.component);
            keyParts.push(data.id);
            return keyParts.join('.');
        }
        getExperiencePerformanceKey(data) {
            const keyParts = [
                this.getPrefix(data),
                'fe',
                data.performanceType
            ];
            if (data.platform) keyParts.push(data.platform.component);
            keyParts.push(data.id);
            return keyParts.join('.');
        }
        getExperiencePerformanceType(data) {
            return data.performanceType;
        }
        getPerformanceMetrics(data) {
            return {
                'event:key': this.getExperiencePerformanceKey(data),
                'event:type': this.getExperiencePerformanceType(data),
                ...(0, (0, parcelRequire("ep4ut")).getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
                ...this.getPluginsMetrics(data)
            };
        }
        constructor(){
            this.gasv3 = null;
            this.product = '';
            this.region = $02c157c65157adaa$var$UNKNOWN_VALUE;
            this.hostname = (0, (0, parcelRequire("8Vhtb")).getWindowObject)()?.location?.hostname || '';
            this.tenantType = (0, (0, parcelRequire("9na5h")).TenantType).RealUser;
            this.app = {
                version: {
                    web: $02c157c65157adaa$var$UNKNOWN_VALUE
                }
            };
            this.performanceConfig = {};
            this.buffer = [];
            this.featureFlagClient = null;
            this.featureFlags = [];
            this.ssr = null;
            this.resourceTimings = null;
            this.bundleEvalTimings = null;
            this.route = (0, (0, parcelRequire("e1BKK")).Route);
            this.plugins = null;
            this.allowlist = ()=>true;
            this.getPluginsMetrics = (data)=>{
                const result = {};
                if (this.plugins) this.plugins.forEach((plugin)=>{
                    const pluginOutput = plugin({
                        ...data
                    });
                    if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                    Object.entries(pluginOutput).forEach(([key, value])=>{
                        result[`${this.product}:${key}`] = value;
                    });
                });
                return result;
            };
        }
    }
    const $02c157c65157adaa$export$edb879ae55bb9be3 = new $02c157c65157adaa$var$Publisher();
});
const $46f5b02486779691$export$93809551debf385f = '0.1.7';
parcelRegister("9na5h", function(module, exports) {
    $parcel$export(module.exports, "TenantType", ()=>$5c9ba10207f863ae$export$92a757ac1398962f);
    var $5c9ba10207f863ae$export$92a757ac1398962f;
    (function(TenantType) {
        TenantType["RealUser"] = "real-user";
        TenantType["Synthetic"] = "synthetic";
    })($5c9ba10207f863ae$export$92a757ac1398962f || ($5c9ba10207f863ae$export$92a757ac1398962f = {}));
});
parcelRegister("cnlxp", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStream", ()=>$a15afbfb62c8af6a$export$faf4c91b80fc830e);
    var $eoXiD;
    var $fSTSz;
    class $a15afbfb62c8af6a$export$faf4c91b80fc830e {
        push(event) {
            (0, (0, parcelRequire("eoXiD")).ufolog)('EVENT STREAM push', event.type, event.payload);
            if (event.type === (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
            if (event.type === (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
            if (event.type === (0, (0, parcelRequire("fSTSz")).UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
        }
        publish(eventPayload) {
            if (this.subscribers[0, (0, parcelRequire("fSTSz")).SUBSCRIBE_ALL]) this.subscribers[0, (0, parcelRequire("fSTSz")).SUBSCRIBE_ALL].forEach((fn)=>{
                fn(eventPayload);
            });
            this.subscribers[eventPayload.id]?.forEach((fn)=>{
                fn(eventPayload);
            });
        }
        subscribe(experienceId, fn) {
            (0, (0, parcelRequire("eoXiD")).ufolog)('EVENT STREAM subscribe', experienceId);
            if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
            this.subscribers[experienceId].push(fn);
        }
        unsubscribe(experienceId, fn) {
            const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
            if (index !== -1) this.subscribers[experienceId].splice(index, 1);
        }
        constructor(){
            this.__buffer_only__ = false;
            this.subscribers = {};
        }
    }
});
parcelRegister("ep4ut", function(module, exports) {
    $parcel$export(module.exports, "getPerformancePayload", ()=>$d4de3328a66dae38$export$738d24377baf6a5e);
    var $atdLB;
    var $fSTSz;
    var $dK6It;
    var $kWdyU;
    var $k4Pve;
    var $eAj4U;
    var $h6gEY;
    const $d4de3328a66dae38$var$LoadMetricKeys = {
        tti: 'metric:tti',
        fmp: 'metric:fmp',
        ttiHistograms: 'metric:tti:histogramBuckets',
        fmpHistograms: 'metric:fmp:histogramBuckets'
    };
    const $d4de3328a66dae38$var$InlineResultMetricKeys = {
        result: 'metric:result',
        response: 'metric:response',
        resultHistograms: 'metric:result:histogramBuckets',
        responseHistograms: 'metric:response:histogramBuckets'
    };
    const $d4de3328a66dae38$var$CustomMetricKeys = {
        duration: 'metric:duration',
        durationHistograms: 'metric:duration:histogramBuckets'
    };
    const $d4de3328a66dae38$var$getHistogram = (data, performanceConfig, isInitial)=>{
        let histogram = {};
        if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
        else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
        if (histogram) {
            const histograms = histogram[data.performanceType];
            switch(data.performanceType){
                case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad:
                case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad:
                    const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                    return histograms ? {
                        [$d4de3328a66dae38$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                        [$d4de3328a66dae38$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                    } : {};
                case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult:
                    return histograms ? {
                        [$d4de3328a66dae38$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                        [$d4de3328a66dae38$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                    } : {};
                case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom:
                    return histograms ? {
                        [$d4de3328a66dae38$var$CustomMetricKeys.durationHistograms]: histograms.duration
                    } : {};
            }
        }
    };
    const $d4de3328a66dae38$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("fSTSz")).FMP_MARK))?.time || (0, (0, parcelRequire("dK6It")).isInitialPageLoad)(data) && ssr?.getDoneMark();
        const tti = data.metrics.endTime - data.metrics.startTime;
        const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
        return {
            [$d4de3328a66dae38$var$LoadMetricKeys.tti]: Math.round(tti),
            [$d4de3328a66dae38$var$LoadMetricKeys.fmp]: Math.round(fmp),
            ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
        };
    };
    const $d4de3328a66dae38$export$47f0208fd62dffce = (data, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("fSTSz")).INLINE_RESPONSE_MARK));
        const result = data.metrics.endTime - data.metrics.startTime;
        const response = responseMark ? responseMark.time - data.metrics.startTime : result;
        return {
            [$d4de3328a66dae38$var$InlineResultMetricKeys.result]: Math.round(result),
            [$d4de3328a66dae38$var$InlineResultMetricKeys.response]: Math.round(response),
            ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
        };
    };
    const $d4de3328a66dae38$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const duration = data.metrics.endTime - data.metrics.startTime;
        return {
            [$d4de3328a66dae38$var$CustomMetricKeys.duration]: Math.round(duration),
            ...$d4de3328a66dae38$var$getHistogram(data, performanceConfig)
        };
    };
    const $d4de3328a66dae38$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
        switch(data.performanceType){
            case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad:
            case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad:
                return $d4de3328a66dae38$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
            case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult:
                return $d4de3328a66dae38$export$47f0208fd62dffce(data, performanceConfig);
            case (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom:
                return $d4de3328a66dae38$export$c25c1b3ff2ce92cf(data, performanceConfig);
        }
    };
    const $d4de3328a66dae38$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
        return {
            ...$d4de3328a66dae38$var$getPerformanceMetrics(data, ssr, performanceConfig),
            ...(0, (0, parcelRequire("h6gEY")).resourceTimings)(data, resourceConfig),
            ...(0, (0, parcelRequire("eAj4U")).bundleEvalTimings)(data, bundleEvalConfig),
            ...(0, (0, parcelRequire("k4Pve")).appTimings)(data, ssr),
            ...(0, (0, parcelRequire("dK6It")).isInitialPageLoad)(data) ? (0, (0, parcelRequire("kWdyU")).navigationMetrics)() : null
        };
    };
});
parcelRegister("dK6It", function(module, exports) {
    $parcel$export(module.exports, "isInitialPageLoad", ()=>$0b4a58e4d2769f2b$export$7167d96e9881d500);
    var $atdLB;
    const $0b4a58e4d2769f2b$export$7167d96e9881d500 = (data)=>{
        return data.performanceType === (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad && data.initial === true;
    };
});
parcelRegister("kWdyU", function(module, exports) {
    $parcel$export(module.exports, "navigationMetrics", ()=>$c5ac08be6ac9d8e8$export$b88d990436be0f8a);
    const $c5ac08be6ac9d8e8$export$b88d990436be0f8a = ()=>{
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        const metrics = {
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart)
        };
        return {
            'metrics:navigation': metrics
        };
    };
});
parcelRegister("k4Pve", function(module, exports) {
    $parcel$export(module.exports, "appTimings", ()=>$78cb488cd4728639$export$e952f50a4f2d02da);
    var $atdLB;
    var $dK6It;
    var $86du4;
    var $gtOjE;
    const $78cb488cd4728639$export$e952f50a4f2d02da = (data, ssrConfig)=>{
        const explicitTimings = data.performanceType === (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
        const timings = (0, (0, parcelRequire("86du4")).customTimings)(data);
        const ssr = (0, (0, parcelRequire("dK6It")).isInitialPageLoad)(data) ? (0, (0, parcelRequire("gtOjE")).ssrTimings)(ssrConfig) : null;
        const timingsApp = (explicitTimings || timings || ssr) && {
            ...explicitTimings,
            ...timings,
            ...ssr
        };
        if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
        return {
            'timings:app': timingsApp
        };
    };
});
parcelRegister("86du4", function(module, exports) {
    $parcel$export(module.exports, "customTimings", ()=>$8b95ee7a7ad3b9c4$export$6126f85083a72c6e);
    const $8b95ee7a7ad3b9c4$var$retrieveTimings = (data)=>{
        const configTimings = data.timings || [];
        const timings = configTimings.reduce((entries, timing)=>{
            const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
            if (timing.startMark && !startMark) return entries;
            const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
            if (timing.endMark && !endMark) return entries;
            if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
            const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
            const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
            entries[`${timing.key}`] = {
                startTime: startTime,
                duration: duration
            };
            return entries;
        }, {});
        return timings;
    };
    const $8b95ee7a7ad3b9c4$export$6126f85083a72c6e = (data)=>{
        if (!data.timings) return null;
        const timings = $8b95ee7a7ad3b9c4$var$retrieveTimings(data);
        if (Object.keys(timings).length === 0) return null;
        return timings;
    };
});
parcelRegister("gtOjE", function(module, exports) {
    $parcel$export(module.exports, "ssrTimings", ()=>$8088f1c47096c2e3$export$130f411261a599c5);
    const $8088f1c47096c2e3$var$filterEntry = (entry)=>{
        return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    };
    const $8088f1c47096c2e3$var$mapEntry = (entry)=>{
        return {
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        };
    };
    const $8088f1c47096c2e3$var$SSR_PREFIX = 'ssr';
    const $8088f1c47096c2e3$var$mapKey = (key)=>{
        if (key === 'total') return $8088f1c47096c2e3$var$SSR_PREFIX;
        return `${$8088f1c47096c2e3$var$SSR_PREFIX}${0, $088984e189011c8c$export$b98e411ae80c806f}${key}`;
    };
    const $8088f1c47096c2e3$export$130f411261a599c5 = (ssr)=>{
        if (!ssr?.getTimings) return null;
        const timings = ssr.getTimings();
        if (!timings) return null;
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($8088f1c47096c2e3$var$filterEntry(entry[1])) acc[$8088f1c47096c2e3$var$mapKey(entry[0])] = $8088f1c47096c2e3$var$mapEntry(entry[1]);
            return acc;
        }, {});
        if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
        return ssrTimings;
    };
});
const $088984e189011c8c$export$b98e411ae80c806f = '/';
parcelRegister("eAj4U", function(module, exports) {
    $parcel$export(module.exports, "bundleEvalTimings", ()=>$4fa9087c35bbbe76$export$1a2bb347935fc536);
    var $8Vhtb;
    const $4fa9087c35bbbe76$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)() || undefined)=>{
        if (!bundleEvalTimings) return null;
        const started = {};
        const timings = {};
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = bundleEvalTimings.mapPerformanceMark(mark.name);
            if (!result || data.result.startTime === null) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= data.result.startTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: Math.round(started[name].startTime - data.result.startTime),
                    duration: Math.round(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
            const result = bundleEvalTimings.additionalTimings(data.result.startTime);
            if (result) Object.entries(result).forEach(([key, value])=>{
                timings[key] = value;
            });
        }
        if (Object.keys(timings).length === 0) return null;
        return {
            'timings:bundleEval': timings
        };
    };
});
parcelRegister("8Vhtb", function(module, exports) {
    $parcel$export(module.exports, "getWindowObject", ()=>$17273a97381df088$export$9aa44f85591248d9);
    $parcel$export(module.exports, "getPerformanceObject", ()=>$17273a97381df088$export$8cd0c777b0eb66a0);
    $parcel$export(module.exports, "getPerformanceObserverObject", ()=>$17273a97381df088$export$74560fd4e61fd440);
    const $17273a97381df088$export$9aa44f85591248d9 = ()=>{
        return typeof window !== 'undefined' && !!window ? window : undefined;
    };
    const $17273a97381df088$export$8cd0c777b0eb66a0 = ()=>{
        const { performance: performance } = $17273a97381df088$export$9aa44f85591248d9() || {};
        return performance;
    };
    const $17273a97381df088$export$74560fd4e61fd440 = ()=>{
        const { PerformanceObserver: PerformanceObserver } = $17273a97381df088$export$9aa44f85591248d9() || {};
        return PerformanceObserver;
    };
});
parcelRegister("h6gEY", function(module, exports) {
    $parcel$export(module.exports, "resourceTimings", ()=>$260cdb61c1527b3f$export$81a7d52441a06b50);
    var $8Vhtb;
    var $dFbEk;
    const $260cdb61c1527b3f$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $260cdb61c1527b3f$var$resourceTypes = [
        'fetch',
        'xmlhttprequest'
    ];
    const $260cdb61c1527b3f$var$CACHE_NETWORK = 'network';
    const $260cdb61c1527b3f$var$CACHE_MEMORY = 'memory';
    const $260cdb61c1527b3f$var$CACHE_DISK = 'disk';
    const $260cdb61c1527b3f$var$calculateTransferType = (type, duration, size)=>{
        if (!$260cdb61c1527b3f$var$cacheableTypes.includes(type)) return $260cdb61c1527b3f$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $260cdb61c1527b3f$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $260cdb61c1527b3f$var$CACHE_DISK;
        if (size === undefined) return null;
        return $260cdb61c1527b3f$var$CACHE_NETWORK;
    };
    const $260cdb61c1527b3f$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
        return !$260cdb61c1527b3f$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, (0, parcelRequire("8Vhtb")).getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
    };
    const $260cdb61c1527b3f$var$getReportedInitiatorTypes = (xhrEnabled)=>{
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    };
    const $260cdb61c1527b3f$var$evaluateAccessToResourceTimings = (_url, entry)=>{
        return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
    };
    const $260cdb61c1527b3f$var$getSizeObject = (size)=>size !== undefined ? {
            size: size
        } : null;
    const $260cdb61c1527b3f$var$getNetworkData = (item, eventStart, hasTimingHeaders = $260cdb61c1527b3f$var$evaluateAccessToResourceTimings)=>{
        const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
        const ttfb = Math.round(responseStart - eventStart);
        if (!$260cdb61c1527b3f$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
        if ($260cdb61c1527b3f$var$cacheableTypes.includes(initiatorType)) {
            const transferType = $260cdb61c1527b3f$var$calculateTransferType(initiatorType, duration, transferSize);
            if (!transferType) return {
                ttfb: ttfb,
                ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
            };
            if (transferType !== $260cdb61c1527b3f$var$CACHE_NETWORK) return {
                transferType: transferType
            };
            return {
                ttfb: ttfb,
                transferType: transferType,
                ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
            };
        }
        return {
            ttfb: ttfb,
            ...$260cdb61c1527b3f$var$getSizeObject(transferSize)
        };
    };
    const $260cdb61c1527b3f$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)() || undefined)=>{
        if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
        const resources = (0, (0, parcelRequire("dFbEk")).getResourceTimings)(data.result.startTime, performance);
        if (!resources?.length) return null;
        const resourceTiming = {};
        const { xhrFilter: xhrFilter } = resourceTimings;
        const reportedInitiatorTypes = $260cdb61c1527b3f$var$getReportedInitiatorTypes(!!xhrFilter);
        resources.forEach((item)=>{
            if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
            const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
            if (!name || data.result.startTime === null) return;
            if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
            const url = $260cdb61c1527b3f$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
            if (!url || resourceTiming[url]) return;
            resourceTiming[url] = {
                startTime: Math.round(startTime - data.result.startTime),
                duration: Math.round(duration),
                workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
                fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
                type: initiatorType,
                ...$260cdb61c1527b3f$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
            };
        });
        return {
            'timings:resource': resourceTiming
        };
    };
});
parcelRegister("dFbEk", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$f5d2a8d6860f3f5c$export$bea963256235a63e);
    $parcel$export(module.exports, "getResourceTimings", ()=>$f5d2a8d6860f3f5c$export$9eebb59359c2e9e5);
    var $eoXiD;
    var $8Vhtb;
    const $f5d2a8d6860f3f5c$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>({
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: Math.round(entry.startTime),
                duration: Math.round(entry.duration),
                fetchStart: Math.round(entry.fetchStart || 0),
                workerStart: Math.round(entry.workerStart || 0),
                responseStart: Math.round(entry.responseStart || 0)
            }),
        start: (performance = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)(), PerformanceObserver1 = (0, (0, parcelRequire("8Vhtb")).getPerformanceObserverObject)())=>{
            if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
            if ($f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
                (0, (0, parcelRequire("eoXiD")).ufologger).warn('Observer is already running');
                return;
            }
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $f5d2a8d6860f3f5c$export$bea963256235a63e.timings = resources.map((resource)=>$f5d2a8d6860f3f5c$export$bea963256235a63e.transformResource(resource));
            $f5d2a8d6860f3f5c$export$bea963256235a63e.observer = new PerformanceObserver1($f5d2a8d6860f3f5c$export$bea963256235a63e.addTimings);
            $f5d2a8d6860f3f5c$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
                $f5d2a8d6860f3f5c$export$bea963256235a63e.observer.disconnect();
                $f5d2a8d6860f3f5c$export$bea963256235a63e.observer = null;
            }
            $f5d2a8d6860f3f5c$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$f5d2a8d6860f3f5c$export$bea963256235a63e.transformResource(entry));
            const overflow = $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $f5d2a8d6860f3f5c$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $f5d2a8d6860f3f5c$export$bea963256235a63e.maxSize;
                $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $f5d2a8d6860f3f5c$export$9eebb59359c2e9e5 = (startTime, performance = (0, (0, parcelRequire("8Vhtb")).getPerformanceObject)())=>{
        if (!PerformanceObserver || !$f5d2a8d6860f3f5c$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
            return null;
        }
        return $f5d2a8d6860f3f5c$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
    };
});
parcelRegister("jdaZR", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleState", ()=>$a63b5db026909530$export$723b4c298aca63af);
    var $fSTSz;
    const $a63b5db026909530$export$723b4c298aca63af = (data)=>{
        return {
            'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, (0, parcelRequire("fSTSz")).PageVisibleState).HIDDEN : (0, (0, parcelRequire("fSTSz")).PageVisibleState).VISIBLE)
        };
    };
});
parcelRegister("1rlqb", function(module, exports) {
    $parcel$export(module.exports, "appFramework", ()=>$21d864dabdcdfb99$export$e34e4529b979f74c);
    const $21d864dabdcdfb99$export$e34e4529b979f74c = (config)=>{
        if (!config.framework) return null;
        return {
            'app:framework:name': config.framework.name,
            'app:framework:version': config.framework.version
        };
    };
});
parcelRegister("8vdI1", function(module, exports) {
    $parcel$export(module.exports, "appVersion", ()=>$8f2169abe7fc39d7$export$82ae485178b37419);
    const $8f2169abe7fc39d7$export$82ae485178b37419 = (config)=>{
        const pluginData = {
            'app:web:version': config.version.web
        };
        if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
        return pluginData;
    };
});
parcelRegister("7xyGJ", function(module, exports) {
    $parcel$export(module.exports, "eventBrowserPlugin", ()=>$0b31bf64269c47f7$export$f435c2789ca334a7);
    var $4XKM3 = parcelRequire("4XKM3");
    var $8QpSo;
    var $8Vhtb;
    const $0b31bf64269c47f7$export$f435c2789ca334a7 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!(0, ($parcel$interopDefault($4XKM3))).getParser) return null;
        const browser = (0, ($parcel$interopDefault($4XKM3))).getParser((0, (0, parcelRequire("8Vhtb")).getWindowObject)()?.navigator?.userAgent || '');
        return {
            'event:browser:name': browser.getBrowserName(),
            'event:browser:version': browser.getBrowserVersion()
        };
    });
});
parcelRegister("6IMTA", function(module, exports) {
    $parcel$export(module.exports, "eventCpusPlugin", ()=>$1f74a632b6b19522$export$db7649b8854107ad);
    var $8QpSo;
    const $1f74a632b6b19522$export$db7649b8854107ad = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!navigator.hardwareConcurrency) return null;
        return {
            'event:cpus': navigator.hardwareConcurrency
        };
    });
});
parcelRegister("dc6Kb", function(module, exports) {
    $parcel$export(module.exports, "featureFlags", ()=>$2bd20537fe6c7bf9$export$e62953d023125748);
    const $2bd20537fe6c7bf9$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
        const allFeatureFlags = [
            ...featureFlags,
            ...data.featureFlags || []
        ];
        if (allFeatureFlags.length === 0) return null;
        const initialMemo = [];
        allFeatureFlags.reduce((memo, featureFlagKey)=>{
            const ffVal = featureFlagClient.getValue(featureFlagKey);
            if (ffVal !== undefined && ffVal !== null) memo.push([
                featureFlagKey,
                ffVal
            ]);
            return memo;
        }, initialMemo);
        const mappedFeatureFlags = Object.fromEntries(initialMemo);
        return {
            featureFlags: mappedFeatureFlags
        };
    };
});
parcelRegister("aHGCE", function(module, exports) {
    $parcel$export(module.exports, "eventMemoryPlugin", ()=>$f0ec20b3c2496535$export$81efaf8414879a1a);
    var $8QpSo;
    const $f0ec20b3c2496535$export$81efaf8414879a1a = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!navigator.deviceMemory) return null;
        return {
            'event:memory': navigator.deviceMemory
        };
    });
});
parcelRegister("l4Z6i", function(module, exports) {
    $parcel$export(module.exports, "eventNetworkPlugin", ()=>$3b5d10e1054ac5c5$export$ce1cf816dce1da56);
    const $3b5d10e1054ac5c5$export$ce1cf816dce1da56 = ()=>{
        if (!navigator.connection) return null;
        return {
            'event:network:effectiveType': navigator.connection.effectiveType,
            'event:network:rtt': navigator.connection.rtt,
            'event:network:downlink': navigator.connection.downlink
        };
    };
});
parcelRegister("4btcP", function(module, exports) {
    $parcel$export(module.exports, "ssrFeatureFlags", ()=>$4d6e8c27f9546e1d$export$fdbea518c19dfa8);
    const $4d6e8c27f9546e1d$export$fdbea518c19dfa8 = (ssr)=>{
        if (!ssr?.getFeatureFlags) return null;
        try {
            const featureFlags = ssr.getFeatureFlags();
            if (featureFlags) return {
                'ssr:featureFlags': featureFlags
            };
        } catch (e) {}
        return null;
    };
});
parcelRegister("foo60", function(module, exports) {
    $parcel$export(module.exports, "ssrSuccess", ()=>$5bf66f80ee72a63e$export$a3dc8251cf55b2e0);
    const $5bf66f80ee72a63e$export$a3dc8251cf55b2e0 = (ssr)=>{
        if (ssr?.getDoneMark()) return {
            'ssr:success': true
        };
        return null;
    };
});
parcelRegister("e1BKK", function(module, exports) {
    $parcel$export(module.exports, "Route", ()=>$3acce3639a350de3$export$e7b0ac011bb776c6);
    const $3acce3639a350de3$export$e7b0ac011bb776c6 = {
        route: '',
        setRoute (newRoute) {
            this.route = newRoute;
        },
        getRoute () {
            return this.route;
        }
    };
});
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx';
const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';
const $16271ea4123e88a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $16271ea4123e88a6$export$f005e2e9f707cb5f = 'commercial';
const $16271ea4123e88a6$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $16271ea4123e88a6$export$a739cd5aac835909 = 'stg';
const $16271ea4123e88a6$export$42dd0cdd351a4a9 = 'prod';
const $16271ea4123e88a6$export$404582bc18fe4d9e = 'dev';
const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;
$parcel$global.rlb("i5RRW");
